{
  "schemaVersion": "1.0.0",
  "version": "letters-light-type-library/1.0.0",
  "generatedOn": "2026-07-20T12:24:05.202Z",
  "curationSha256": "7c70940f5f3f389140b0e2738f72a543423aecafdbe59b77c274b4d5e17103a0",
  "provider": {
    "name": "Google Fonts",
    "repository": "https://github.com/google/fonts",
    "commit": "389b770410cc0b7c21c85673bfa2077420fe7f65",
    "runtimeRequests": 0
  },
  "policy": {
    "exactFilesRequiredForPreview": true,
    "allowedLicenses": [
      "OFL-1.1"
    ],
    "remoteRuntimeFontsForbidden": true,
    "recommendationDoesNotClaimDeckApplicationValidation": true
  },
  "shelves": [
    {
      "id": "clear-workhorses",
      "label": "Clear workhorses",
      "description": "Calm families that carry argument, evidence and handoff without becoming wallpaper.",
      "class": "sans",
      "character": "quiet",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "clear",
        "plainspoken",
        "rigorous",
        "calm"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not confuse neutrality with an excuse to make every slide identical."
    },
    {
      "id": "warm-humanists",
      "label": "Warm humanists",
      "description": "Open forms and human rhythm for decks that need warmth without performing friendliness.",
      "class": "sans",
      "character": "present",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "warm",
        "open",
        "human",
        "approachable"
      ],
      "artifacts": [
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "filmTvProject",
        "other"
      ],
      "lanes": [
        "reliable",
        "characterful",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not round every corner until the argument loses its spine."
    },
    {
      "id": "geometric-voices",
      "label": "Geometric voices",
      "description": "Designed presence for titles that should be remembered without shouting at the body copy.",
      "class": "sans",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate",
        "varied"
      ],
      "tones": [
        "graphic",
        "contemporary",
        "confident",
        "constructed"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "startupInvestor",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not let the display face colonize paragraphs, labels and footnotes."
    },
    {
      "id": "condensed-impact",
      "label": "Condensed impact",
      "description": "Space-efficient display voices for covers, chapter cards and large-room statements.",
      "class": "condensed-sans",
      "character": "expressive",
      "roles": [
        "display",
        "utility"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "compressed",
        "urgent",
        "poster-like",
        "decisive"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch",
        "salesPartnership"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not use condensed width to preserve copy that should have been edited."
    },
    {
      "id": "editorial-reading",
      "label": "Editorial reading",
      "description": "Serifs with enough stamina for treatments, narrative decks and argument that needs pace.",
      "class": "serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "editorial",
        "literary",
        "measured",
        "credible"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "companyCredentials",
        "other"
      ],
      "lanes": [
        "editorial",
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not use literary texture as permission for paragraphs that should be slides apart."
    },
    {
      "id": "expressive-serif",
      "label": "Expressive serif",
      "description": "Display faces with texture, contrast and an actual opinion.",
      "class": "display-serif",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "dramatic",
        "tactile",
        "authored",
        "cinematic"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "editorial",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not turn every sentence into a costume change."
    },
    {
      "id": "sturdy-serifs",
      "label": "Sturdy serifs",
      "description": "Serifs that can hold numbers, product detail and long argument without becoming polite wallpaper.",
      "class": "sturdy-serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "sturdy",
        "grounded",
        "substantial",
        "practical"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "editorial",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not mistake weight for authority; hierarchy still has to do the work."
    },
    {
      "id": "data-utility",
      "label": "Data and utility",
      "description": "Monospaced companions for numbers, evidence, labels and technical material—not a cyberpunk personality transplant.",
      "class": "mono",
      "character": "present",
      "roles": [
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "technical",
        "precise",
        "measured",
        "functional"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "utility"
      ],
      "oneThingNotToDo": "Do not dress ordinary prose as code to make the deck look technical."
    }
  ],
  "fonts": [
    {
      "id": "antonio",
      "family": "Antonio",
      "slug": "antonio",
      "shelfId": "condensed-impact",
      "class": "condensed-sans",
      "character": "expressive",
      "roles": [
        "display",
        "utility"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "compressed",
        "urgent",
        "poster-like",
        "decisive"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch",
        "salesPartnership"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not use condensed width to preserve copy that should have been edited.",
      "designer": "Vernon Adams",
      "category": "DISPLAY",
      "dateAdded": "2013-03-06",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 700
        }
      ],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/antonio/OFL.txt",
        "localFile": "public/fonts/type-library/antonio/OFL.txt",
        "sha256": "ae9a754b006df720bb6721e7b78c04990df734f87195c6033140fceab60bebf6"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/antonio/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Antonio%3Awght%40100..700&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/antonioFont",
        "upstreamCommit": "08562998b10c6c21a3505f47236b42f5d58c9909",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/antonio/normal-100-700-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/antonio/normal-100-700-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/antonio/v22/gNMEW3NwSYq_9WD3yHoiFaWw9MPZPA.woff2",
          "sha256": "edc6d5a6614e872cfdc23c8b56abd8091430c3d643147dd190ebcc048b613923",
          "bytes": 16280,
          "style": "normal",
          "weight": "100 700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/antonio/normal-100-700-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/antonio/normal-100-700-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/antonio/v22/gNMEW3NwSYq_9WD3yHQiFaWw9MM.woff2",
          "sha256": "36f69209fa73db22731b8ba05121df80fcb25322a3ddf5f2e80f9098cbfaad8b",
          "bytes": 26548,
          "style": "normal",
          "weight": "100 700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "archivoNarrow",
      "family": "Archivo Narrow",
      "slug": "archivonarrow",
      "shelfId": "condensed-impact",
      "class": "condensed-sans",
      "character": "expressive",
      "roles": [
        "display",
        "utility"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "compressed",
        "urgent",
        "poster-like",
        "decisive"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch",
        "salesPartnership"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not use condensed width to preserve copy that should have been edited.",
      "designer": "Omnibus-Type",
      "category": "SANS_SERIF",
      "dateAdded": "2012-09-18",
      "subsets": [
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 400,
          "max": 700
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/archivonarrow/OFL.txt",
        "localFile": "public/fonts/type-library/archivoNarrow/OFL.txt",
        "sha256": "b2087ef3fb91248e346600d19021249152a9688efea72905aa1996bb16a4c8de"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/archivonarrow/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Archivo+Narrow%3Aital%2Cwght%400%2C400..700%3B1%2C400..700&display=swap",
        "upstreamRepository": "https://github.com/Omnibus-Type/ArchivoNarrow",
        "upstreamCommit": "9793ec77b6682a26bc7a6ed523ca65cc3cb90aec",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/archivoNarrow/italic-400-700-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/archivoNarrow/italic-400-700-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/archivonarrow/v35/tss2ApVBdCYD5Q7hcxTE1ArZ0bb1uXB63v0qNxhX5Q.woff2",
          "sha256": "31c3c62800c4875ee1748f9da50a2850d053c1f54b31f4f9ad329d5912f8544d",
          "bytes": 18020,
          "style": "italic",
          "weight": "400 700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/archivoNarrow/italic-400-700-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/archivoNarrow/italic-400-700-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/archivonarrow/v35/tss2ApVBdCYD5Q7hcxTE1ArZ0bb1uX563v0qNxg.woff2",
          "sha256": "a83fb9855f693a83f38c98f45132529a65958bcbd79ded07698c3c67c2af29bd",
          "bytes": 21016,
          "style": "italic",
          "weight": "400 700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/archivoNarrow/normal-400-700-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/archivoNarrow/normal-400-700-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/archivonarrow/v35/tss0ApVBdCYD5Q7hcxTE1ArZ0bb-iXxw2d8oBxk.woff2",
          "sha256": "db821b657f1d6b362a8bbddb4452073d156cea76854a157d3b33b4a999fcebfa",
          "bytes": 16580,
          "style": "normal",
          "weight": "400 700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/archivoNarrow/normal-400-700-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/archivoNarrow/normal-400-700-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/archivonarrow/v35/tss0ApVBdCYD5Q7hcxTE1ArZ0bbwiXxw2d8o.woff2",
          "sha256": "728b32e94fd137eca605f80d3c34adeaeef0d312425c7a5a1ff743407b2d78f9",
          "bytes": 18724,
          "style": "normal",
          "weight": "400 700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "arvo",
      "family": "Arvo",
      "slug": "arvo",
      "shelfId": "sturdy-serifs",
      "class": "sturdy-serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "sturdy",
        "grounded",
        "substantial",
        "practical"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "editorial",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not mistake weight for authority; hierarchy still has to do the work.",
      "designer": "Anton Koovit",
      "category": "SERIF",
      "dateAdded": "2010-11-17",
      "subsets": [
        "latin",
        "menu"
      ],
      "axes": [],
      "hasItalic": true,
      "weights": [
        400,
        700
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/arvo/OFL.txt",
        "localFile": "public/fonts/type-library/arvo/OFL.txt",
        "sha256": "359671bf16c00cae69cb66d041296b2adc7a4becd73a463cb8c5e101d97c7986"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/arvo/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Arvo%3Aital%2Cwght%400%2C400%3B1%2C400%3B0%2C700%3B1%2C700&display=swap",
        "upstreamRepository": "https://github.com/antonxheight/Arvo",
        "upstreamCommit": "ae906e99ab549103549c68252edfcb1816a6bf08",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/arvo/italic-400-normal-latin-1.woff2",
          "publicUrl": "/fonts/type-library/arvo/italic-400-normal-latin-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/arvo/v23/tDbN2oWUg0MKqSIg75Tv3PjyjA.woff2",
          "sha256": "ca5d893bd27551f1d4916a3ad734cc8926596f6ded9abc2d94e80029199afb35",
          "bytes": 11008,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/arvo/italic-700-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/arvo/italic-700-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/arvo/v23/tDbO2oWUg0MKqSIoVLH68dr_pgL0Gw.woff2",
          "sha256": "c5675657d8243882f32e1dc2c68c73cc677905ee472a8de9bc2b146c79d66660",
          "bytes": 11320,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/arvo/normal-400-normal-latin-3.woff2",
          "publicUrl": "/fonts/type-library/arvo/normal-400-normal-latin-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/arvo/v23/tDbD2oWUg0MKqScQ7Z7o_vo.woff2",
          "sha256": "8d344107e41e882422818bda0a76729341a14e47c4e7764bae4e31f2e015c242",
          "bytes": 10612,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/arvo/normal-700-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/arvo/normal-700-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/arvo/v23/tDbM2oWUg0MKoZw1-LPK89D4hAA.woff2",
          "sha256": "b0f02c443508ee385aa8f90625fc7ceeac8ebe55474fe0791a9438ea3e7ee373",
          "bytes": 10668,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "atkinsonHyperlegibleNext",
      "family": "Atkinson Hyperlegible Next",
      "slug": "atkinsonhyperlegiblenext",
      "shelfId": "clear-workhorses",
      "class": "sans",
      "character": "quiet",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "open",
        "accessible-minded",
        "direct"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not confuse neutrality with an excuse to make every slide identical.",
      "designer": "Braille Institute, Applied Design Works, Elliott Scott, Megan Eiswerth, Letters From Sweden",
      "category": "SANS_SERIF",
      "dateAdded": "2025-01-07",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 200,
          "max": 800
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/atkinsonhyperlegiblenext/OFL.txt",
        "localFile": "public/fonts/type-library/atkinsonHyperlegibleNext/OFL.txt",
        "sha256": "aca6a428580965d2297d1b718042dd427c2a9443ece3b0d02d758e161e0c4030"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/atkinsonhyperlegiblenext/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible+Next%3Aital%2Cwght%400%2C200..800%3B1%2C200..800&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/atkinson-hyperlegible-next",
        "upstreamCommit": "7925f50f649b3813257faf2f4c0b381011f434f1",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/atkinsonHyperlegibleNext/italic-200-800-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/atkinsonHyperlegibleNext/italic-200-800-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/atkinsonhyperlegiblenext/v7/NaPPcYPdHfdVxJw0IfIP0lvYFqijb-UxCtm5_wdGseiMr3a-oWR9e2WPJQ.woff2",
          "sha256": "871436be3c2e0104442463df5eabe7eaef5e0172cb6715a720156ef76f70e1ff",
          "bytes": 20240,
          "style": "italic",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/atkinsonHyperlegibleNext/italic-200-800-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/atkinsonHyperlegibleNext/italic-200-800-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/atkinsonhyperlegiblenext/v7/NaPPcYPdHfdVxJw0IfIP0lvYFqijb-UxCtm5_wdGseiMr3i-oWR9e2U.woff2",
          "sha256": "6e221fe2869a755fdce1ba6c3517f392c3a218d642e1d0207ed2826713db7263",
          "bytes": 37596,
          "style": "italic",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/atkinsonHyperlegibleNext/normal-200-800-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/atkinsonHyperlegibleNext/normal-200-800-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/atkinsonhyperlegiblenext/v7/NaPNcYPdHfdVxJw0IfIP0lvYFqijb-UxCtm5_wdGseiHn3q0pkZ_S2Q.woff2",
          "sha256": "ca1969afa9058a41ced4a08bd54f48835cfe79dc6ccf9050dca7da85c9e0a9d9",
          "bytes": 19076,
          "style": "normal",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/atkinsonHyperlegibleNext/normal-200-800-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/atkinsonHyperlegibleNext/normal-200-800-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/atkinsonhyperlegiblenext/v7/NaPNcYPdHfdVxJw0IfIP0lvYFqijb-UxCtm5_wdGseiJn3q0pkZ_.woff2",
          "sha256": "1e4cea71d75ec427581d6259fc07148a2e60d60d16cabf4b4f5360487b3f9dc3",
          "bytes": 34024,
          "style": "normal",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "azeretMono",
      "family": "Azeret Mono",
      "slug": "azeretmono",
      "shelfId": "data-utility",
      "class": "mono",
      "character": "present",
      "roles": [
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "technical",
        "precise",
        "measured",
        "functional"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "utility"
      ],
      "oneThingNotToDo": "Do not dress ordinary prose as code to make the deck look technical.",
      "designer": "Displaay, Martin Vácha",
      "category": "MONOSPACE",
      "dateAdded": "2021-06-08",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/azeretmono/OFL.txt",
        "localFile": "public/fonts/type-library/azeretMono/OFL.txt",
        "sha256": "2a0fd31798d131b38a9fe730a260bc9a1d85452e36cdf79e5fcaf937bf4d9f86"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/azeretmono/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Azeret+Mono%3Aital%2Cwght%400%2C100..900%3B1%2C100..900&display=swap",
        "upstreamRepository": "https://github.com/displaay/Azeret",
        "upstreamCommit": "3d45a6c3e094f08bfc70551b525bd2037cac51ba",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/azeretMono/italic-100-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/azeretMono/italic-100-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/azeretmono/v21/3XFsErsiyJsY9O_Gepph-HHkVfX82dZIZ0SnVQ.woff2",
          "sha256": "e6a52318127c0758f9966d9a7a72080ae726d17ceea0c80af82b973733125dfc",
          "bytes": 15712,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/azeretMono/italic-100-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/azeretMono/italic-100-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/azeretmono/v21/3XFsErsiyJsY9O_Gepph-HHkVfv82dZIZ0Q.woff2",
          "sha256": "05a822ff9d9566c1bd7c42aa0fdc2254f2a8ab290dd554270e530323a3849e7b",
          "bytes": 28500,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/azeretMono/normal-100-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/azeretMono/normal-100-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/azeretmono/v21/3XFuErsiyJsY9O_Gepph-HHvZfn23vRKV0U.woff2",
          "sha256": "0a54e0e864a389e175ea83383a55b9e00bab49213ff9d63e7b03a0b91874c940",
          "bytes": 14732,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/azeretMono/normal-100-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/azeretMono/normal-100-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/azeretmono/v21/3XFuErsiyJsY9O_Gepph-HHhZfn23vRK.woff2",
          "sha256": "20cbb538069d5e673d5135054371558b78716564ad2ed9aabfa3112cd060306c",
          "bytes": 26216,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "barlowCondensed",
      "family": "Barlow Condensed",
      "slug": "barlowcondensed",
      "shelfId": "condensed-impact",
      "class": "condensed-sans",
      "character": "expressive",
      "roles": [
        "display",
        "utility"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "compressed",
        "urgent",
        "poster-like",
        "decisive"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch",
        "salesPartnership"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not use condensed width to preserve copy that should have been edited.",
      "designer": "Jeremy Tribby",
      "category": "SANS_SERIF",
      "dateAdded": "2017-10-26",
      "subsets": [
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [],
      "hasItalic": true,
      "weights": [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/barlowcondensed/OFL.txt",
        "localFile": "public/fonts/type-library/barlowCondensed/OFL.txt",
        "sha256": "186d750eb496a4c17a76385f82be6aea2ac1cf2de074a811d63786cf374ea73f"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/barlowcondensed/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Barlow+Condensed%3Aital%2Cwght%400%2C400%3B1%2C400%3B0%2C700%3B1%2C700&display=swap",
        "upstreamRepository": "https://github.com/jpt/barlow",
        "upstreamCommit": "b4726ddf91525818e85e5fce111c285b9273d764",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/barlowCondensed/italic-400-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/barlowCondensed/italic-400-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/barlowcondensed/v13/HTxxL3I-JCGChYJ8VI-L6OO_au7B6xTj1lHzlqsLaoJN.woff2",
          "sha256": "1eead60aef1aa5df8fd844551ca56fa18f7a0abc2ca98adaae60f9c81a053dff",
          "bytes": 9980,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/barlowCondensed/italic-400-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/barlowCondensed/italic-400-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/barlowcondensed/v13/HTxxL3I-JCGChYJ8VI-L6OO_au7B6xTj2FHzlqsLag.woff2",
          "sha256": "b195e01a6e677fa7c08462c4c1b20f92ceba01755be6da66bd04c048583a0ca1",
          "bytes": 16672,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/barlowCondensed/italic-700-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/barlowCondensed/italic-700-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/barlowcondensed/v13/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrY3TmtYkGQLhEx6A5.woff2",
          "sha256": "241d0840af819ac18027933c98a818e5afbdbcb81b288c977fe017d6b30e5cfe",
          "bytes": 9988,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/barlowCondensed/italic-700-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/barlowCondensed/italic-700-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/barlowcondensed/v13/HTxyL3I-JCGChYJ8VI-L6OO_au7B6xTrY3Tmu4kGQLhExw.woff2",
          "sha256": "d55f5f9f9adf4928557a328efd8cdfd9acf21e72f9dd0ed9c8d1a3538df1418b",
          "bytes": 16348,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/barlowCondensed/normal-400-normal-latin-ext-5.woff2",
          "publicUrl": "/fonts/type-library/barlowCondensed/normal-400-normal-latin-ext-5.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/barlowcondensed/v13/HTx3L3I-JCGChYJ8VI-L6OO_au7B6x_T2lv0tKk7aw.woff2",
          "sha256": "ed8618e86bffee6caa69d0aa5c08339fa886d878962444348b09b2e5ec2d516c",
          "bytes": 9264,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/barlowCondensed/normal-400-normal-latin-6.woff2",
          "publicUrl": "/fonts/type-library/barlowCondensed/normal-400-normal-latin-6.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/barlowcondensed/v13/HTx3L3I-JCGChYJ8VI-L6OO_au7B6xHT2lv0tKk.woff2",
          "sha256": "0e2a408159b32d8105bcd1a0a4d6222fcee375a84fb62703c614ce34d8bb68bb",
          "bytes": 14672,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/barlowCondensed/normal-700-normal-latin-ext-7.woff2",
          "publicUrl": "/fonts/type-library/barlowCondensed/normal-700-normal-latin-ext-7.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/barlowcondensed/v13/HTxwL3I-JCGChYJ8VI-L6OO_au7B46r2z3jWuYMBYrp0xg.woff2",
          "sha256": "0c1655655b5a1fa18382367f471b943c8e009c5cf36a3898433babd92fc606e2",
          "bytes": 9328,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/barlowCondensed/normal-700-normal-latin-8.woff2",
          "publicUrl": "/fonts/type-library/barlowCondensed/normal-700-normal-latin-8.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/barlowcondensed/v13/HTxwL3I-JCGChYJ8VI-L6OO_au7B46r2z3bWuYMBYro.woff2",
          "sha256": "e3e520cb7468f2efd60bc2ce96694567c3312f4ef414fffbe605e3ad146b24e6",
          "bytes": 14888,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "bebasNeue",
      "family": "Bebas Neue",
      "slug": "bebasneue",
      "shelfId": "condensed-impact",
      "class": "condensed-sans",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "compressed",
        "urgent",
        "poster-like",
        "decisive"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch",
        "salesPartnership"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not use condensed width to preserve copy that should have been edited.",
      "designer": "Ryoichi Tsunekawa",
      "category": "DISPLAY",
      "dateAdded": "2019-10-16",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/bebasneue/OFL.txt",
        "localFile": "public/fonts/type-library/bebasNeue/OFL.txt",
        "sha256": "72082f6cb4d04be2ecf7cc7d9e1e7d73787f0af8a5a278a47cade70c16b78341"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/bebasneue/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Bebas+Neue%3Awght%40400&display=swap",
        "upstreamRepository": "https://github.com/dharmatype/Bebas-Neue",
        "upstreamCommit": "686d14af640c17af3691c597778f121d840d9051",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/bebasNeue/normal-400-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/bebasNeue/normal-400-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/bebasneue/v16/JTUSjIg69CK48gW7PXoo9WdhyyTh89ZNpQ.woff2",
          "sha256": "a724a4b6a8844a50c489b60294d308818f43a244213b0d687d2ba72cf6cee746",
          "bytes": 5664,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/bebasNeue/normal-400-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/bebasNeue/normal-400-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/bebasneue/v16/JTUSjIg69CK48gW7PXoo9WlhyyTh89Y.woff2",
          "sha256": "441b026df205d28954f61b6989c7bbd228c0adff42f746a266c6a5d89134bc34",
          "bytes": 8596,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "besley",
      "family": "Besley",
      "slug": "besley",
      "shelfId": "sturdy-serifs",
      "class": "sturdy-serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "sturdy",
        "grounded",
        "substantial",
        "practical"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "editorial",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not mistake weight for authority; hierarchy still has to do the work.",
      "designer": "Owen Earl",
      "category": "SERIF",
      "dateAdded": "2021-01-05",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 400,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/besley/OFL.txt",
        "localFile": "public/fonts/type-library/besley/OFL.txt",
        "sha256": "e8d81ba3b06080b764626d4385f319344e102ddf2c08bb4209412ac22d695f69"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/besley/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Besley%3Aital%2Cwght%400%2C400..900%3B1%2C400..900&display=swap",
        "upstreamRepository": "https://github.com/indestructible-type/Besley",
        "upstreamCommit": "eb8b1b7f62f9f328e4be345d3e5928fefba3c38e",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/besley/italic-400-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/besley/italic-400-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/besley/v22/PlI-FlO1MaNwaNG8WTeL0Hlun8y4RX8.woff2",
          "sha256": "b5951d00a749fba8b76f1a9a9a3b813fa05aa9ce8c9847625eefb8f29f0275db",
          "bytes": 19480,
          "style": "italic",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/besley/italic-400-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/besley/italic-400-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/besley/v22/PlI-FlO1MaNwaNG8WTeF0Hlun8y4.woff2",
          "sha256": "ec105d312314968e4efdcff9b1038f99d945147a903c82f0d29f155525737561",
          "bytes": 39476,
          "style": "italic",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/besley/normal-400-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/besley/normal-400-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/besley/v22/PlI8FlO1MaNwaNG8UgeH2n5Mnfy5.woff2",
          "sha256": "337267656e241c6baf831680a013d3e8b4c223871870c16e8522531656fbc96f",
          "bytes": 18440,
          "style": "normal",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/besley/normal-400-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/besley/normal-400-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/besley/v22/PlI8FlO1MaNwaNG8XAeH2n5MnQ.woff2",
          "sha256": "f6acafeade510fcd949a828d210b8b917350030eb039e64b20e8c8a7580ed1b1",
          "bytes": 36532,
          "style": "normal",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "bigShouldersDisplay",
      "family": "Big Shoulders Display",
      "slug": "bigshouldersdisplay",
      "shelfId": "condensed-impact",
      "class": "condensed-sans",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "compressed",
        "urgent",
        "poster-like",
        "decisive"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch",
        "salesPartnership"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not use condensed width to preserve copy that should have been edited.",
      "designer": "Patric King",
      "category": "DISPLAY",
      "dateAdded": "2019-09-11",
      "subsets": [
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/bigshouldersdisplay/OFL.txt",
        "localFile": "public/fonts/type-library/bigShouldersDisplay/OFL.txt",
        "sha256": "338f9c050f19daeda1d597243faf79f3a3d437c338af58cb7047617d0ce08771"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/bigshouldersdisplay/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Big+Shoulders+Display%3Awght%40100..900&display=swap",
        "upstreamRepository": "https://github.com/xotypeco/big_shoulders",
        "upstreamCommit": "41153e6fe01d218e933919a1d08c8e45065bc8fe",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/bigShouldersDisplay/normal-100-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/bigShouldersDisplay/normal-100-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/bigshouldersdisplay/v24/fC1_PZJEZG-e9gHhdI4-NBbfd2ys3SjJCx1cwtDuDJAM23AZ.woff2",
          "sha256": "8a2768ca71f8db60855e512408d497853be30eddb011d9845d25e62944457972",
          "bytes": 29464,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/bigShouldersDisplay/normal-100-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/bigShouldersDisplay/normal-100-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/bigshouldersdisplay/v24/fC1_PZJEZG-e9gHhdI4-NBbfd2ys3SjJCx1czNDuDJAM2w.woff2",
          "sha256": "203dd8ba4ae61b19cd2e00c66708f0d0f6d8484cdfdb1d7e8be37260d36a99b1",
          "bytes": 35520,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "bitter",
      "family": "Bitter",
      "slug": "bitter",
      "shelfId": "sturdy-serifs",
      "class": "sturdy-serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "sturdy",
        "grounded",
        "substantial",
        "practical"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "editorial",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not mistake weight for authority; hierarchy still has to do the work.",
      "designer": "Sol Matas",
      "category": "SERIF",
      "dateAdded": "2011-12-19",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/bitter/OFL.txt",
        "localFile": "public/fonts/type-library/bitter/OFL.txt",
        "sha256": "152a1e283e23b42c4940da4c72f2f5bebaa17969cb77c76d7af05903846006f1"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/bitter/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Bitter%3Aital%2Cwght%400%2C100..900%3B1%2C100..900&display=swap",
        "upstreamRepository": "https://github.com/solmatas/BitterPro",
        "upstreamCommit": "3238d7ae2cb0b564b81225d68b3c893a40b1d3ce",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/bitter/italic-100-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/bitter/italic-100-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/bitter/v42/rax-HiqOu8IVPmn7erxlJD1wmULYyT8.woff2",
          "sha256": "11aa915cc048dad1545d43eb51a870fda0be6c944a64f23da6ba0e3ab62baf55",
          "bytes": 31704,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/bitter/italic-100-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/bitter/italic-100-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/bitter/v42/rax-HiqOu8IVPmn7erxrJD1wmULY.woff2",
          "sha256": "b3254bd6e8f606dd900f30fa980dbaa1e9b3df651653e3bda0c6d2fe1806e0d5",
          "bytes": 33376,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/bitter/normal-100-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/bitter/normal-100-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/bitter/v42/rax8HiqOu8IVPmn7cYxpLjpSm3LZ.woff2",
          "sha256": "40fbac4477f9bfd82fa57662e54c6eedea543956c2e7952a09cd95bbc70642d8",
          "bytes": 32824,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/bitter/normal-100-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/bitter/normal-100-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/bitter/v42/rax8HiqOu8IVPmn7f4xpLjpSmw.woff2",
          "sha256": "261cfc4d27941b2774efba0a2b03872ddc001dca4423aa3ce278e80301423c1b",
          "bytes": 34156,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "bodoniModa",
      "family": "Bodoni Moda",
      "slug": "bodonimoda",
      "shelfId": "expressive-serif",
      "class": "display-serif",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "dramatic",
        "tactile",
        "authored",
        "cinematic"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "editorial",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not turn every sentence into a costume change.",
      "designer": "Owen Earl",
      "category": "SERIF",
      "dateAdded": "2020-11-25",
      "subsets": [
        "latin",
        "latin-ext",
        "math",
        "menu",
        "symbols"
      ],
      "axes": [
        {
          "tag": "opsz",
          "min": 6,
          "max": 96
        },
        {
          "tag": "wght",
          "min": 400,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/bodonimoda/OFL.txt",
        "localFile": "public/fonts/type-library/bodoniModa/OFL.txt",
        "sha256": "931dfe2e0cd3c9443295f5c1d754b8a8403bf060df50c1d5900267ade83d0046"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/bodonimoda/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Bodoni+Moda%3Aital%2Copsz%2Cwght%400%2C6..96%2C400..900%3B1%2C6..96%2C400..900&display=swap",
        "upstreamRepository": "https://github.com/indestructible-type/Bodoni",
        "upstreamCommit": "30ce6cdc354ef179a3b72ba0f0e71826e599348c",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/bodoniModa/italic-400-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/bodoniModa/italic-400-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/bodonimoda/v28/aFTS7PxzY382XsXX63LUYJSPeKTcW3JNsapGZQ.woff2",
          "sha256": "028e7c63074f7f64d914b48cdf490c8b6c275a960509f885e55dd9d4b5fa8550",
          "bytes": 28008,
          "style": "italic",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/bodoniModa/italic-400-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/bodoniModa/italic-400-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/bodonimoda/v28/aFTS7PxzY382XsXX63LUYJSPeKrcW3JNsao.woff2",
          "sha256": "3fac62d55a70c44bce64ff97db280b6b1c346575ea4c26c99b40eaf2367511b5",
          "bytes": 53640,
          "style": "italic",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/bodoniModa/normal-400-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/bodoniModa/normal-400-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/bodonimoda/v28/aFTQ7PxzY382XsXX63LUYJSESKjWXFBPgas.woff2",
          "sha256": "e00904cd96a4b289e3e56f9f12c59d2f49b33f56baf384336534e61024c088d0",
          "bytes": 24952,
          "style": "normal",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/bodoniModa/normal-400-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/bodoniModa/normal-400-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/bodonimoda/v28/aFTQ7PxzY382XsXX63LUYJSKSKjWXFBP.woff2",
          "sha256": "fe710b15e2acd1f30159cec96b10c3455a32d27104c29d4027c5465d81fc11fe",
          "bytes": 46248,
          "style": "normal",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "breeSerif",
      "family": "Bree Serif",
      "slug": "breeserif",
      "shelfId": "sturdy-serifs",
      "class": "sturdy-serif",
      "character": "present",
      "roles": [
        "display"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "sturdy",
        "grounded",
        "substantial",
        "practical"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "editorial",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not mistake weight for authority; hierarchy still has to do the work.",
      "designer": "TypeTogether",
      "category": "SERIF",
      "dateAdded": "2011-12-19",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/breeserif/OFL.txt",
        "localFile": "public/fonts/type-library/breeSerif/OFL.txt",
        "sha256": "fbe0442a6b1ce162c95e241df76cab5ef2daf6a5ac84ae1a7a6749f32c051098"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/breeserif/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Bree+Serif%3Awght%40400&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/breeserif",
        "upstreamCommit": "80b004f6325a65a90f50de70facec1c98d36ff9d",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/breeSerif/normal-400-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/breeSerif/normal-400-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/breeserif/v18/4UaHrEJCrhhnVA3DgluA96Tp57F2IwN-Pw.woff2",
          "sha256": "e547591908b5f2ccbc6768ed28ff886a269bc8dbc239cfdbe413945f519f4da3",
          "bytes": 6440,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/breeSerif/normal-400-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/breeSerif/normal-400-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/breeserif/v18/4UaHrEJCrhhnVA3DgluA96rp57F2IwM.woff2",
          "sha256": "c98e913e6fea11b2156ce085787737d3c53924f80a007535c06eb2968c110cc1",
          "bytes": 10360,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "bricolageGrotesque",
      "family": "Bricolage Grotesque",
      "slug": "bricolagegrotesque",
      "shelfId": "geometric-voices",
      "class": "sans",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate",
        "varied"
      ],
      "tones": [
        "elastic",
        "odd",
        "editorial"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "startupInvestor",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not let the display face colonize paragraphs, labels and footnotes.",
      "designer": "Mathieu Triay",
      "category": "SANS_SERIF",
      "dateAdded": "2023-06-15",
      "subsets": [
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "opsz",
          "min": 12,
          "max": 96
        },
        {
          "tag": "wdth",
          "min": 75,
          "max": 100
        },
        {
          "tag": "wght",
          "min": 200,
          "max": 800
        }
      ],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/bricolagegrotesque/OFL.txt",
        "localFile": "public/fonts/type-library/bricolageGrotesque/OFL.txt",
        "sha256": "4b5a7d8f37f5602621c8a8d7358a6a2e71317e6c231c661e15aef0275d3e07ba"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/bricolagegrotesque/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Bricolage+Grotesque%3Aopsz%2Cwdth%2Cwght%4012..96%2C75..100%2C200..800&display=swap",
        "upstreamRepository": "https://github.com/ateliertriay/bricolage",
        "upstreamCommit": "84745e5b96261ae5f8c6c856e262fe78d1d6efdd",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/bricolageGrotesque/normal-200-800-75-100-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/bricolageGrotesque/normal-200-800-75-100-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/bricolagegrotesque/v9/3y996as8bTXq_nANBjzKo3IeZx8z6up5L-aNGfyOPPtQPw.woff2",
          "sha256": "104b93499342ede4da68d37234be0e5229345f0be0b9509328f3071f5fb9e8c8",
          "bytes": 53648,
          "style": "normal",
          "weight": "200 800",
          "stretch": "75% 100%",
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/bricolageGrotesque/normal-200-800-75-100-latin-2.woff2",
          "publicUrl": "/fonts/type-library/bricolageGrotesque/normal-200-800-75-100-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/bricolagegrotesque/v9/3y996as8bTXq_nANBjzKo3IeZx8z6up5L-iNGfyOPPs.woff2",
          "sha256": "9fee080fcc2d2e0ea8c7ce2a58abaa8ba1f40c6e603643327cd5eb6f07db06a8",
          "bytes": 131312,
          "style": "normal",
          "weight": "200 800",
          "stretch": "75% 100%",
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "cormorantGaramond",
      "family": "Cormorant Garamond",
      "slug": "cormorantgaramond",
      "shelfId": "expressive-serif",
      "class": "display-serif",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "dramatic",
        "tactile",
        "authored",
        "cinematic"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "editorial",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not turn every sentence into a costume change.",
      "designer": "Christian Thalmann",
      "category": "SERIF",
      "dateAdded": "2017-01-18",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 300,
          "max": 700
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/cormorantgaramond/OFL.txt",
        "localFile": "public/fonts/type-library/cormorantGaramond/OFL.txt",
        "sha256": "60700d351cac4650c51f3f9db318d2a420f8b45052dba2715eb5fec41f0f6956"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/cormorantgaramond/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Cormorant+Garamond%3Aital%2Cwght%400%2C300..700%3B1%2C300..700&display=swap",
        "upstreamRepository": "https://github.com/CatharsisFonts/Cormorant",
        "upstreamCommit": "6d210fd3550b7358ca62d6ba3e354ec1ec940813",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/cormorantGaramond/italic-300-700-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/cormorantGaramond/italic-300-700-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/cormorantgaramond/v21/co3ZmX5slCNuHLi8bLeY9MK7whWMhyjYrEtGmSqn7B6DxjY.woff2",
          "sha256": "06bc9a8c179afaf7dd5d3b4987ad2f4a82ca85a542c9e498b18bf32ad0257d8e",
          "bytes": 34444,
          "style": "italic",
          "weight": "300 700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/cormorantGaramond/italic-300-700-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/cormorantGaramond/italic-300-700-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/cormorantgaramond/v21/co3ZmX5slCNuHLi8bLeY9MK7whWMhyjYrEtImSqn7B6D.woff2",
          "sha256": "e6d6d1d73858aa9b66f3a3539f9dec22faab2276e61ad1d813bc04dd59c9c122",
          "bytes": 39304,
          "style": "italic",
          "weight": "300 700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/cormorantGaramond/normal-300-700-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/cormorantGaramond/normal-300-700-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/cormorantgaramond/v21/co3bmX5slCNuHLi8bLeY9MK7whWMhyjYp3tKky2F7i6C.woff2",
          "sha256": "9dc38267bdee93a653200ef3c1e8060e3f1399073432c415c683b419d3b50464",
          "bytes": 33740,
          "style": "normal",
          "weight": "300 700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/cormorantGaramond/normal-300-700-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/cormorantGaramond/normal-300-700-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/cormorantgaramond/v21/co3bmX5slCNuHLi8bLeY9MK7whWMhyjYqXtKky2F7g.woff2",
          "sha256": "5d618c462b7a5b74f442e1548880086af71764d9cc7d35c16ab45353da934621",
          "bytes": 37776,
          "style": "normal",
          "weight": "300 700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "crimsonPro",
      "family": "Crimson Pro",
      "slug": "crimsonpro",
      "shelfId": "editorial-reading",
      "class": "serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "editorial",
        "literary",
        "measured",
        "credible"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "companyCredentials",
        "other"
      ],
      "lanes": [
        "editorial",
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not use literary texture as permission for paragraphs that should be slides apart.",
      "designer": "Jacques Le Bailly",
      "category": "SERIF",
      "dateAdded": "2018-12-05",
      "subsets": [
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 200,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/crimsonpro/OFL.txt",
        "localFile": "public/fonts/type-library/crimsonPro/OFL.txt",
        "sha256": "1820869bd5baa1c2d88fa87c89eea532cf9442d841008acab720654b7f82823d"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/crimsonpro/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Crimson+Pro%3Aital%2Cwght%400%2C200..900%3B1%2C200..900&display=swap",
        "upstreamRepository": "https://github.com/Fonthausen/CrimsonPro",
        "upstreamCommit": "24e8f7bf59ec45d77c67879ad80d97e5f94c787b",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/crimsonPro/italic-200-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/crimsonPro/italic-200-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/crimsonpro/v28/q5uBsoa5M_tv7IihmnkabARekY1wDeChrlWhBw.woff2",
          "sha256": "0ad667be0c601c5a843945ef747d88e12558e264023d1bec92ea1f51257835fb",
          "bytes": 39852,
          "style": "italic",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/crimsonPro/italic-200-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/crimsonPro/italic-200-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/crimsonpro/v28/q5uBsoa5M_tv7IihmnkabARekYNwDeChrlU.woff2",
          "sha256": "f6e346888097c3dd29a15620fdd1a727af7df5a71d7dc3c2c84f8682bc2cd716",
          "bytes": 51376,
          "style": "italic",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/crimsonPro/normal-200-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/crimsonPro/normal-200-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/crimsonpro/v28/q5uDsoa5M_tv7IihmnkabARVoYF6CsKjnlQ.woff2",
          "sha256": "0ff3122e6772fdfd6835723dfd60f11f244fc6f87720d6811317a4cc580a065c",
          "bytes": 37888,
          "style": "normal",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/crimsonPro/normal-200-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/crimsonPro/normal-200-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/crimsonpro/v28/q5uDsoa5M_tv7IihmnkabARboYF6CsKj.woff2",
          "sha256": "89374859da8085dbce486eed120a12abcab5a90e725f8b9c41a3e2b32bd010f6",
          "bytes": 48152,
          "style": "normal",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "dmSans",
      "family": "DM Sans",
      "slug": "dmsans",
      "shelfId": "clear-workhorses",
      "class": "sans",
      "character": "quiet",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "clear",
        "plainspoken",
        "rigorous",
        "calm"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not confuse neutrality with an excuse to make every slide identical.",
      "designer": "Colophon Foundry",
      "category": "SANS_SERIF",
      "dateAdded": "2019-06-12",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "opsz",
          "min": 9,
          "max": 40
        },
        {
          "tag": "wght",
          "min": 100,
          "max": 1000
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/dmsans/OFL.txt",
        "localFile": "public/fonts/type-library/dmSans/OFL.txt",
        "sha256": "9af36190332437f5ecd09974de43c1f7c77a310a996cdd8ceb25628b458840e1"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/dmsans/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=DM+Sans%3Aital%2Copsz%2Cwght%400%2C9..40%2C100..1000%3B1%2C9..40%2C100..1000&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/dm-fonts",
        "upstreamCommit": "d0520ba03bd780f5dccb3024854463d44f699b78",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/dmSans/italic-100-1000-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/dmSans/italic-100-1000-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/dmsans/v17/rP2Fp2ywxg089UriCZa4ET-DJF4e8BH9.woff2",
          "sha256": "c34301ff2989cd3bae2c557b1bcab88d826be1357da17ebf8e158a773853b5a1",
          "bytes": 40880,
          "style": "italic",
          "weight": "100 1000",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/dmSans/italic-100-1000-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/dmSans/italic-100-1000-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/dmsans/v17/rP2Fp2ywxg089UriCZa4Hz-DJF4e8A.woff2",
          "sha256": "06596e93170b0e13b8f1b60b93774c4d317e4a15c83ce106634090c603142d2f",
          "bytes": 76176,
          "style": "italic",
          "weight": "100 1000",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/dmSans/normal-100-1000-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/dmSans/normal-100-1000-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/dmsans/v17/rP2Hp2ywxg089UriCZ2IHTWEBlwu8Q.woff2",
          "sha256": "0d0609aee778d21b40bda1d27b7e6b5b3cb1a3e96b90b8831c681aca097c2219",
          "bytes": 31312,
          "style": "normal",
          "weight": "100 1000",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/dmSans/normal-100-1000-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/dmSans/normal-100-1000-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/dmsans/v17/rP2Hp2ywxg089UriCZOIHTWEBlw.woff2",
          "sha256": "aa530716b0d351866af7dbfa3eee4120fb36f2d071baff8c234185141865c7ff",
          "bytes": 62556,
          "style": "normal",
          "weight": "100 1000",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "dmSerifDisplay",
      "family": "DM Serif Display",
      "slug": "dmserifdisplay",
      "shelfId": "expressive-serif",
      "class": "display-serif",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "dramatic",
        "tactile",
        "authored",
        "cinematic"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "editorial",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not turn every sentence into a costume change.",
      "designer": "Colophon Foundry",
      "category": "SERIF",
      "dateAdded": "2019-06-12",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/dmserifdisplay/OFL.txt",
        "localFile": "public/fonts/type-library/dmSerifDisplay/OFL.txt",
        "sha256": "a3e5cdd67d4571dd0a24fcc968de0efde7ae97ef752daf0906e4767619dd7231"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/dmserifdisplay/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=DM+Serif+Display%3Aital%2Cwght%400%2C400%3B1%2C400&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/dm-fonts",
        "upstreamCommit": "027cea4e4f45827128860a4dec7b9a0852a295d7",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/dmSerifDisplay/italic-400-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/dmSerifDisplay/italic-400-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/dmserifdisplay/v17/-nFhOHM81r4j6k0gjAW3mujVU2B2G_VB3vD2xWr53BJl.woff2",
          "sha256": "432390010167ff2a4377385f17789727e52fbfcfd8d4b810bbfaf5f60e032e7f",
          "bytes": 7244,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/dmSerifDisplay/italic-400-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/dmSerifDisplay/italic-400-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/dmserifdisplay/v17/-nFhOHM81r4j6k0gjAW3mujVU2B2G_VB0PD2xWr53A.woff2",
          "sha256": "94b0e8fc568c1361f31de02a91297adf78a5a926f4a86932f22643e504cd012f",
          "bytes": 17660,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/dmSerifDisplay/normal-400-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/dmSerifDisplay/normal-400-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/dmserifdisplay/v17/-nFnOHM81r4j6k0gjAW3mujVU2B2G_5x0vrx52jJ3Q.woff2",
          "sha256": "dfea1d6549e78df6e55d942c1d1eba5e2f809496205bc0b3a9d684f268b60011",
          "bytes": 6800,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/dmSerifDisplay/normal-400-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/dmSerifDisplay/normal-400-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/dmserifdisplay/v17/-nFnOHM81r4j6k0gjAW3mujVU2B2G_Bx0vrx52g.woff2",
          "sha256": "f273cf2c9ce9bc7d6b0f4fcb8aee72f8cf5a249991308b6a144217e0760c5d3f",
          "bytes": 17844,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "figtree",
      "family": "Figtree",
      "slug": "figtree",
      "shelfId": "clear-workhorses",
      "class": "sans",
      "character": "quiet",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "clear",
        "plainspoken",
        "rigorous",
        "calm"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not confuse neutrality with an excuse to make every slide identical.",
      "designer": "Erik Kennedy",
      "category": "SANS_SERIF",
      "dateAdded": "2022-07-21",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 300,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/figtree/OFL.txt",
        "localFile": "public/fonts/type-library/figtree/OFL.txt",
        "sha256": "140d37233e7f3ce7313798befa9600893bcceaf41a55fa0fa5ad52f7f657a268"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/figtree/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Figtree%3Aital%2Cwght%400%2C300..900%3B1%2C300..900&display=swap",
        "upstreamRepository": "https://github.com/erikdkennedy/figtree",
        "upstreamCommit": "032dfa7fe219ef3a02890d6d3add84eacc9aebfe",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/figtree/italic-300-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/figtree/italic-300-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/figtree/v9/_Xmu-HUzqDCFdgfMm4GNAa5o7Cqcs8-2.woff2",
          "sha256": "12fc79a7d84899371587d5d5d7d8f46594132d8f6a36fe2559dea603b364822f",
          "bytes": 10364,
          "style": "italic",
          "weight": "300 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/figtree/italic-300-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/figtree/italic-300-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/figtree/v9/_Xmu-HUzqDCFdgfMm4GND65o7Cqcsw.woff2",
          "sha256": "ba0e9e20f91b8ba39cabca32e7f323c2e453b0badb563899b5e728d68cd97614",
          "bytes": 20836,
          "style": "italic",
          "weight": "300 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/figtree/normal-300-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/figtree/normal-300-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/figtree/v9/_Xms-HUzqDCFdgfMm4q9DaRvziissg.woff2",
          "sha256": "f153aa07c1b16fbb12391c2512860c97819a0a9fd014f338b2b3f12496479d13",
          "bytes": 10228,
          "style": "normal",
          "weight": "300 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/figtree/normal-300-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/figtree/normal-300-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/figtree/v9/_Xms-HUzqDCFdgfMm4S9DaRvzig.woff2",
          "sha256": "8330490a01c60c196eae00b823de8102275aaa5862e7b76a7af21b8745338928",
          "bytes": 20184,
          "style": "normal",
          "weight": "300 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "fraunces",
      "family": "Fraunces",
      "slug": "fraunces",
      "shelfId": "expressive-serif",
      "class": "display-serif",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "dramatic",
        "tactile",
        "authored",
        "cinematic"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "editorial",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not turn every sentence into a costume change.",
      "designer": "Undercase Type, Phaedra Charles, Flavia Zimbardi",
      "category": "SERIF",
      "dateAdded": "2020-10-29",
      "subsets": [
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "SOFT",
          "min": 0,
          "max": 100
        },
        {
          "tag": "WONK",
          "min": 0,
          "max": 1
        },
        {
          "tag": "opsz",
          "min": 9,
          "max": 144
        },
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/fraunces/OFL.txt",
        "localFile": "public/fonts/type-library/fraunces/OFL.txt",
        "sha256": "bdf4c22802eaf804f998195871c6b8938aac2ac14b2d78a8bd66a6f1eced833b"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/fraunces/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Fraunces%3Aital%2Copsz%2Cwght%400%2C9..144%2C100..900%3B1%2C9..144%2C100..900&display=swap",
        "upstreamRepository": "https://github.com/undercasetype/Fraunces",
        "upstreamCommit": "d6d385783609ceb11ac0f220f3abd9f1631c8a36",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/fraunces/italic-100-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/fraunces/italic-100-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/fraunces/v38/6NU58FyLNQOQZAnv9ZwNjucMHVn85Ni7emAe9lKqZTnbB-gzTK0K1ChjdPeQ7ZXk8kD6.woff2",
          "sha256": "1e0d114a72921799f06413d3673a80c316fa77d8d344df6de7c8659302ece2dc",
          "bytes": 71568,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/fraunces/italic-100-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/fraunces/italic-100-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/fraunces/v38/6NU58FyLNQOQZAnv9ZwNjucMHVn85Ni7emAe9lKqZTnbB-gzTK0K1ChjeveQ7ZXk8g.woff2",
          "sha256": "4af9c759c8059b53923b4b50ba377ba51029876e1af1ea757efb07bc67d97896",
          "bytes": 81704,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/fraunces/normal-100-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/fraunces/normal-100-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/fraunces/v38/6NU78FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0KxCFTeP2Xz5fU8w.woff2",
          "sha256": "f120089b9440f3e35a980a2137347b1851ad46ee4b8ad5c63b6c07e053fa40e2",
          "bytes": 59540,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/fraunces/normal-100-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/fraunces/normal-100-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/fraunces/v38/6NU78FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0KxC9TeP2Xz5c.woff2",
          "sha256": "48282a415ec22e31beaf0a0666e6fae0c8cbddcd0b1f6e729f27c3ade8a64e43",
          "bytes": 67388,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "gabarito",
      "family": "Gabarito",
      "slug": "gabarito",
      "shelfId": "geometric-voices",
      "class": "sans",
      "character": "expressive",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "sparse",
        "moderate",
        "varied"
      ],
      "tones": [
        "lively",
        "informal",
        "direct"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "startupInvestor",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not let the display face colonize paragraphs, labels and footnotes.",
      "designer": "Naipe Foundry, Leandro Assis, Álvaro Franca, Felipe Casaprima",
      "category": "DISPLAY",
      "dateAdded": "2023-09-13",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 400,
          "max": 900
        }
      ],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/gabarito/OFL.txt",
        "localFile": "public/fonts/type-library/gabarito/OFL.txt",
        "sha256": "21506cc7106bbfd4aa1c40371f33f9f4296182a8e4bb46658e99af24feb4bfca"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/gabarito/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Gabarito%3Awght%40400..900&display=swap",
        "upstreamRepository": "https://github.com/naipefoundry/gabarito",
        "upstreamCommit": "1f3fb39d6449eefa880543f109f33ede0cd4064f",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/gabarito/normal-400-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/gabarito/normal-400-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/gabarito/v9/QGYtz_0dZAGKJJ4t3HtmW4XGnfBI2fk.woff2",
          "sha256": "6ec63e9aedc0fc7cb8137c1931dac0ea121a9cd7eb5bf8dd2cf475c5e7fcf450",
          "bytes": 12220,
          "style": "normal",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/gabarito/normal-400-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/gabarito/normal-400-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/gabarito/v9/QGYtz_0dZAGKJJ4t3HtoW4XGnfBI.woff2",
          "sha256": "3f5e6ec227ca614c873d8e0b2502c64d99e96fe3d1bb9f996ab46d2769ad9a2c",
          "bytes": 34320,
          "style": "normal",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "gloock",
      "family": "Gloock",
      "slug": "gloock",
      "shelfId": "expressive-serif",
      "class": "display-serif",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "dramatic",
        "tactile",
        "authored",
        "cinematic"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "editorial",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not turn every sentence into a costume change.",
      "designer": "Duarte Pinto",
      "category": "DISPLAY",
      "dateAdded": "2023-01-06",
      "subsets": [
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/gloock/OFL.txt",
        "localFile": "public/fonts/type-library/gloock/OFL.txt",
        "sha256": "321e28d45a430e017d9d1d6a47ef1fd261aad354723b014cf1933a765036c311"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/gloock/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Gloock%3Awght%40400&display=swap",
        "upstreamRepository": "https://github.com/duartp/gloock",
        "upstreamCommit": "de92978ce821ae0cba86954b4c46abc70486981d",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/gloock/normal-400-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/gloock/normal-400-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/gloock/v8/Iurb6YFw84WUY4NJhhakJLRBjIlJ.woff2",
          "sha256": "89effc4607918017e5345a03fb8d29af3e1e4b6d28e0f42dfb9a074d370c9edb",
          "bytes": 9016,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/gloock/normal-400-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/gloock/normal-400-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/gloock/v8/Iurb6YFw84WUY4NJiBakJLRBjA.woff2",
          "sha256": "b862aac1a16f7dafbf1d2f0115a78f3d216c8a8a83ecd154eb4afb54ade82245",
          "bytes": 17576,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "hankenGrotesk",
      "family": "Hanken Grotesk",
      "slug": "hankengrotesk",
      "shelfId": "warm-humanists",
      "class": "sans",
      "character": "present",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "warm",
        "open",
        "human",
        "approachable"
      ],
      "artifacts": [
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "filmTvProject",
        "other"
      ],
      "lanes": [
        "reliable",
        "characterful",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not round every corner until the argument loses its spine.",
      "designer": "Alfredo Marco Pradil, Hanken Design Co.",
      "category": "SANS_SERIF",
      "dateAdded": "2022-11-16",
      "subsets": [
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/hankengrotesk/OFL.txt",
        "localFile": "public/fonts/type-library/hankenGrotesk/OFL.txt",
        "sha256": "e02ccb89a86839b22feff7872ff5cc355cc0f58318d29eee20e2cf83a612f16d"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/hankengrotesk/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Hanken+Grotesk%3Aital%2Cwght%400%2C100..900%3B1%2C100..900&display=swap",
        "upstreamRepository": "https://github.com/marcologous/hanken-grotesk",
        "upstreamCommit": "1ab416e82130b2d3ddb7710abf7ceabf07156a13",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/hankenGrotesk/italic-100-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/hankenGrotesk/italic-100-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/hankengrotesk/v12/ieVl2YZDLWuGJpnzaiwFXS9tYtpY19y7DQk6YvNkeg.woff2",
          "sha256": "80b363f717e9762ac3a0114d5efd759ce4c2daa143296ccbf3962d2acc34e322",
          "bytes": 20288,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/hankenGrotesk/italic-100-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/hankenGrotesk/italic-100-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/hankengrotesk/v12/ieVl2YZDLWuGJpnzaiwFXS9tYtpY19K7DQk6YvM.woff2",
          "sha256": "99721f51a4d5925d9d08021fb5575ef017fa18a40578ca897485808ce68bc19a",
          "bytes": 35684,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/hankenGrotesk/normal-100-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/hankenGrotesk/normal-100-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/hankengrotesk/v12/ieVn2YZDLWuGJpnzaiwFXS9tYtpT59CxCis4UvI.woff2",
          "sha256": "a1376a563717f1efa2f5286ab23da2b61ae8dec827a77b97adfa01cad4ec4ee2",
          "bytes": 19572,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/hankenGrotesk/normal-100-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/hankenGrotesk/normal-100-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/hankengrotesk/v12/ieVn2YZDLWuGJpnzaiwFXS9tYtpd59CxCis4.woff2",
          "sha256": "1f21c6eaa0000f3329cfcfac966b43d5bebf5aa610303e33294ac31bc6f4bb59",
          "bytes": 34664,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "ibmPlexMono",
      "family": "IBM Plex Mono",
      "slug": "ibmplexmono",
      "shelfId": "data-utility",
      "class": "mono",
      "character": "present",
      "roles": [
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "technical",
        "precise",
        "measured",
        "functional"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "utility"
      ],
      "oneThingNotToDo": "Do not dress ordinary prose as code to make the deck look technical.",
      "designer": "Mike Abbink, Bold Monday",
      "category": "MONOSPACE",
      "dateAdded": "2018-03-12",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [],
      "hasItalic": true,
      "weights": [
        100,
        200,
        300,
        400,
        500,
        600,
        700
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/ibmplexmono/OFL.txt",
        "localFile": "public/fonts/type-library/ibmPlexMono/OFL.txt",
        "sha256": "7e6b2818edbd8f6a01ae80641cc8f16a51080d08fb4e532be3a0b6f74adb07da"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/ibmplexmono/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=IBM+Plex+Mono%3Aital%2Cwght%400%2C400%3B1%2C400%3B0%2C700%3B1%2C700&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/plex",
        "upstreamCommit": "9ab3b5b3b96325fb20f365ee0804adca92024cbf",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/ibmPlexMono/italic-400-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexMono/italic-400-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexmono/v20/-F6pfjptAgt5VM-kVkqdyU8n1ioa23dgregdFOFh.woff2",
          "sha256": "c590f625acd1a18021f23486445b03b8435879b406db1003d3fdd7804e9319fb",
          "bytes": 9788,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/ibmPlexMono/italic-400-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexMono/italic-400-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexmono/v20/-F6pfjptAgt5VM-kVkqdyU8n1ioa1XdgregdFA.woff2",
          "sha256": "2665f5fbbb334780fa135c7f1dc6e2459061a2d6d44c32b7c1fdbc34cde65ede",
          "bytes": 11568,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/ibmPlexMono/italic-700-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexMono/italic-700-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexmono/v20/-F6sfjptAgt5VM-kVkqdyU8n1ioSblJ1jsoQPttoz6Pz.woff2",
          "sha256": "b1ba1f6263ace5830469368dd7ea565d55542ab2850faed8b1c8641bbbc5b3a7",
          "bytes": 9972,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/ibmPlexMono/italic-700-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexMono/italic-700-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexmono/v20/-F6sfjptAgt5VM-kVkqdyU8n1ioSblJ1gMoQPttozw.woff2",
          "sha256": "6b903205e8d5a01239d44ef84848a221b7e4a34d7ac118772907b7160c3fc072",
          "bytes": 11564,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/ibmPlexMono/normal-400-normal-latin-ext-5.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexMono/normal-400-normal-latin-ext-5.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexmono/v20/-F63fjptAgt5VM-kVkqdyU8n1iEq131nj-otFQ.woff2",
          "sha256": "f1050dc5317b43434c0aeda599d4624c774ffc162e87a8cf204b949b6a85816d",
          "bytes": 8860,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/ibmPlexMono/normal-400-normal-latin-6.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexMono/normal-400-normal-latin-6.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexmono/v20/-F63fjptAgt5VM-kVkqdyU8n1i8q131nj-o.woff2",
          "sha256": "c36f509c0a8f9f85f29cb44bc8701d8a9e0b14c499e77a884f789ead7093a7ac",
          "bytes": 10052,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/ibmPlexMono/normal-700-normal-latin-ext-7.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexMono/normal-700-normal-latin-ext-7.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexmono/v20/-F6qfjptAgt5VM-kVkqdyU8n3pQPwl5FgsAXHNlYzg.woff2",
          "sha256": "099842414ddad0cb366cf984641b14e75c01a2c6e3f42fa13a6e89d1f4c3fc20",
          "bytes": 8748,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/ibmPlexMono/normal-700-normal-latin-8.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexMono/normal-700-normal-latin-8.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexmono/v20/-F6qfjptAgt5VM-kVkqdyU8n3pQPwlBFgsAXHNk.woff2",
          "sha256": "9e1455e6e9c5866f607e464fffb7855486dcf575b7e69b83a3d234e587fce41b",
          "bytes": 10128,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "ibmPlexSans",
      "family": "IBM Plex Sans",
      "slug": "ibmplexsans",
      "shelfId": "clear-workhorses",
      "class": "sans",
      "character": "quiet",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "clear",
        "plainspoken",
        "rigorous",
        "calm"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not confuse neutrality with an excuse to make every slide identical.",
      "designer": "Mike Abbink, Bold Monday",
      "category": "SANS_SERIF",
      "dateAdded": "2018-03-12",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wdth",
          "min": 75,
          "max": 100
        },
        {
          "tag": "wght",
          "min": 100,
          "max": 700
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/ibmplexsans/OFL.txt",
        "localFile": "public/fonts/type-library/ibmPlexSans/OFL.txt",
        "sha256": "7e6b2818edbd8f6a01ae80641cc8f16a51080d08fb4e532be3a0b6f74adb07da"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/ibmplexsans/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans%3Aital%2Cwdth%2Cwght%400%2C75..100%2C100..700%3B1%2C75..100%2C100..700&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/plex",
        "upstreamCommit": "3e312890b3b9e47378b30dedfe4196a42151243c",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/ibmPlexSans/italic-100-700-75-100-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexSans/italic-100-700-75-100-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexsans/v23/zYX-KVElMYYaJe8bpLHnCwDKhdTuGaZJW9XjDlN8.woff2",
          "sha256": "7d60e381a4ecd3ece4f26616b818237cd15182c06fd52c5584d11a8c3ae7d3ce",
          "bytes": 47620,
          "style": "italic",
          "weight": "100 700",
          "stretch": "75% 100%",
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/ibmPlexSans/italic-100-700-75-100-latin-2.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexSans/italic-100-700-75-100-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexsans/v23/zYX-KVElMYYaJe8bpLHnCwDKhdTuF6ZJW9XjDg.woff2",
          "sha256": "302a6e67720c3d1c1e435aec15c47122238bf28bb56d1750e8e44319f1d9bba1",
          "bytes": 70536,
          "style": "italic",
          "weight": "100 700",
          "stretch": "75% 100%",
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/ibmPlexSans/normal-100-700-75-100-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexSans/normal-100-700-75-100-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexsans/v23/zYXgKVElMYYaJe8bpLHnCwDKhd_eFaxOedfTDw.woff2",
          "sha256": "5f65d29028a6f2eca291b65adf4c23be83489f126a618bda916e4ee3ad945efb",
          "bytes": 41728,
          "style": "normal",
          "weight": "100 700",
          "stretch": "75% 100%",
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/ibmPlexSans/normal-100-700-75-100-latin-4.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexSans/normal-100-700-75-100-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexsans/v23/zYXgKVElMYYaJe8bpLHnCwDKhdHeFaxOedc.woff2",
          "sha256": "1995c471cc7b5769b72a34e9b08243b585ac456a5dbc65ea6ea6c32afd178c94",
          "bytes": 60364,
          "style": "normal",
          "weight": "100 700",
          "stretch": "75% 100%",
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "ibmPlexSerif",
      "family": "IBM Plex Serif",
      "slug": "ibmplexserif",
      "shelfId": "sturdy-serifs",
      "class": "sturdy-serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "sturdy",
        "grounded",
        "substantial",
        "practical"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "editorial",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not mistake weight for authority; hierarchy still has to do the work.",
      "designer": "Mike Abbink, Bold Monday",
      "category": "SERIF",
      "dateAdded": "2018-03-12",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [],
      "hasItalic": true,
      "weights": [
        100,
        200,
        300,
        400,
        500,
        600,
        700
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/ibmplexserif/OFL.txt",
        "localFile": "public/fonts/type-library/ibmPlexSerif/OFL.txt",
        "sha256": "7e6b2818edbd8f6a01ae80641cc8f16a51080d08fb4e532be3a0b6f74adb07da"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/ibmplexserif/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=IBM+Plex+Serif%3Aital%2Cwght%400%2C400%3B1%2C400%3B0%2C700%3B1%2C700&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/plex",
        "upstreamCommit": "43279c151110b30d65a582261a5ddefd5c75c7be",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/ibmPlexSerif/italic-400-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexSerif/italic-400-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexserif/v20/jizBREVNn1dOx-zrZ2X3pZvkTiUa6zsTjnTLgNuZ5w.woff2",
          "sha256": "512c8c7bbbea0993bb90a1165261ebe7b4effbfab192f09a227eb43f67a2bebd",
          "bytes": 11692,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/ibmPlexSerif/italic-400-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexSerif/italic-400-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexserif/v20/jizBREVNn1dOx-zrZ2X3pZvkTiUa6zUTjnTLgNs.woff2",
          "sha256": "9daa6f3da3e4917e5da8537fe9b42a1d764f967e40920ef91cb1b01e069bd241",
          "bytes": 16024,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/ibmPlexSerif/italic-700-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexSerif/italic-700-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexserif/v20/jizGREVNn1dOx-zrZ2X3pZvkTiUa4442m1fpjfGj7oaMBg.woff2",
          "sha256": "8a7b3b5e426ba6bea3be1b3a1d5b9b035ea5ddac035ae1a69cc0a64bf3965e0a",
          "bytes": 11800,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/ibmPlexSerif/italic-700-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexSerif/italic-700-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexserif/v20/jizGREVNn1dOx-zrZ2X3pZvkTiUa4442m1npjfGj7oY.woff2",
          "sha256": "daa301e8331fdbe2eec684552e2e59132493b5c5bc2d2c3478289436b3e05811",
          "bytes": 16428,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/ibmPlexSerif/normal-400-normal-latin-ext-5.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexSerif/normal-400-normal-latin-ext-5.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexserif/v20/jizDREVNn1dOx-zrZ2X3pZvkTiUR2zcZiVbJsNo.woff2",
          "sha256": "836fd31988bd9b826397032af618e906bfdc80e0c6c25b102e8b9e03353ed5e0",
          "bytes": 10868,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/ibmPlexSerif/normal-400-normal-latin-6.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexSerif/normal-400-normal-latin-6.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexserif/v20/jizDREVNn1dOx-zrZ2X3pZvkTiUf2zcZiVbJ.woff2",
          "sha256": "9fbb32c4c07037bc1e9107ee9cbf3a84662449cb36511138d5adb80e195b9302",
          "bytes": 14916,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/ibmPlexSerif/normal-700-normal-latin-ext-7.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexSerif/normal-700-normal-latin-ext-7.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexserif/v20/jizAREVNn1dOx-zrZ2X3pZvkTi2k_iI6q1vjitOh3oc.woff2",
          "sha256": "c0d6feef8e1f7b546b275e2b5601bcefc080fc1aea2e197e09ba535328cda433",
          "bytes": 10740,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/ibmPlexSerif/normal-700-normal-latin-8.woff2",
          "publicUrl": "/fonts/type-library/ibmPlexSerif/normal-700-normal-latin-8.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/ibmplexserif/v20/jizAREVNn1dOx-zrZ2X3pZvkTi2k_iI0q1vjitOh.woff2",
          "sha256": "8d256fda8c12db0d7bbde004f3e844ba23cfaa3e764880b24056d6f0b79d70dd",
          "bytes": 14936,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "instrumentSerif",
      "family": "Instrument Serif",
      "slug": "instrumentserif",
      "shelfId": "expressive-serif",
      "class": "display-serif",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "dramatic",
        "tactile",
        "authored",
        "cinematic"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "editorial",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not turn every sentence into a costume change.",
      "designer": "Rodrigo Fuenzalida, Jordan Egstad",
      "category": "SERIF",
      "dateAdded": "2023-03-22",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/instrumentserif/OFL.txt",
        "localFile": "public/fonts/type-library/instrumentSerif/OFL.txt",
        "sha256": "129ed7618959716959f2941fdd5b49e0ad6e6c1d78726761786a00253d865521"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/instrumentserif/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Instrument+Serif%3Aital%2Cwght%400%2C400%3B1%2C400&display=swap",
        "upstreamRepository": "https://github.com/Instrument/instrument-serif",
        "upstreamCommit": "65c0ef225f386a3c7e87570a4aa9cc0262c2fd81",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/instrumentSerif/italic-400-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/instrumentSerif/italic-400-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/instrumentserif/v5/jizHRFtNs2ka5fXjeivQ4LroWlx-6zAjgn7Motmp5r61.woff2",
          "sha256": "a04fc7ed18a8037149ce0bfda58076709d8e0840e136ed00abbdc196b7992443",
          "bytes": 8444,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/instrumentSerif/italic-400-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/instrumentSerif/italic-400-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/instrumentserif/v5/jizHRFtNs2ka5fXjeivQ4LroWlx-6zAjjH7Motmp5g.woff2",
          "sha256": "6ee678c33f388dd7ba59700ebea635deb98821baafd817b09891f7927177f702",
          "bytes": 15684,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/instrumentSerif/normal-400-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/instrumentSerif/normal-400-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/instrumentserif/v5/jizBRFtNs2ka5fXjeivQ4LroWlx-6zsTjnTLgNuZ5w.woff2",
          "sha256": "a8c4bd7cd7073180e740d2d83a616b5cb0845579b73207eeafeae8532e70c901",
          "bytes": 7828,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/instrumentSerif/normal-400-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/instrumentSerif/normal-400-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/instrumentserif/v5/jizBRFtNs2ka5fXjeivQ4LroWlx-6zUTjnTLgNs.woff2",
          "sha256": "60c06664b5a95c7de6cc3e00d1f9034d78bd1e40b564016b241674449a067d4d",
          "bytes": 15040,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "inter",
      "family": "Inter",
      "slug": "inter",
      "shelfId": "clear-workhorses",
      "class": "sans",
      "character": "quiet",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "clear",
        "plainspoken",
        "rigorous",
        "calm"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not confuse neutrality with an excuse to make every slide identical.",
      "designer": "Rasmus Andersson",
      "category": "SANS_SERIF",
      "dateAdded": "2020-01-24",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "greek-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "opsz",
          "min": 14,
          "max": 32
        },
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/inter/OFL.txt",
        "localFile": "public/fonts/type-library/inter/OFL.txt",
        "sha256": "5b9321a4298cfeb6b34354164a1c3afc3db114569984c502b9b35d988fd58c57"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/inter/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Inter%3Aital%2Copsz%2Cwght%400%2C14..32%2C100..900%3B1%2C14..32%2C100..900&display=swap",
        "upstreamRepository": "https://www.github.com/rsms/inter",
        "upstreamCommit": "66647c0bbbe41a850d79d9c76fb13add3378940f",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/inter/italic-100-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/inter/italic-100-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/inter/v20/UcCm3FwrK3iLTcvnUwoT9mI1F55MKw.woff2",
          "sha256": "7d263a256b5858b218171435d91c14b299b3aab4eb531f54b92df4ff0a5afe84",
          "bytes": 146648,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/inter/italic-100-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/inter/italic-100-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/inter/v20/UcCm3FwrK3iLTcvnUwQT9mI1F54.woff2",
          "sha256": "124b693f9bb5663329a23e21e3b702ed9ae20a8298a1a7213cd56fc187a16800",
          "bytes": 79744,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/inter/normal-100-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/inter/normal-100-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/inter/v20/UcCo3FwrK3iLTcvsYwYZ8UA3J58.woff2",
          "sha256": "8bc9dee39deab5dc6599980e563c5023053387e4c391f5c419543e493e024c39",
          "bytes": 133704,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/inter/normal-100-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/inter/normal-100-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/inter/v20/UcCo3FwrK3iLTcviYwYZ8UA3.woff2",
          "sha256": "dd8a4575be9806105ac3decd02805cd2782fe7c05abb02c582316bc436ce03ae",
          "bytes": 73016,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "jetBrainsMono",
      "family": "JetBrains Mono",
      "slug": "jetbrainsmono",
      "shelfId": "data-utility",
      "class": "mono",
      "character": "present",
      "roles": [
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "technical",
        "precise",
        "measured",
        "functional"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "utility"
      ],
      "oneThingNotToDo": "Do not dress ordinary prose as code to make the deck look technical.",
      "designer": "JetBrains, Philipp Nurullin, Konstantin Bulenkov",
      "category": "MONOSPACE",
      "dateAdded": "2020-11-18",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 800
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/jetbrainsmono/OFL.txt",
        "localFile": "public/fonts/type-library/jetBrainsMono/OFL.txt",
        "sha256": "b2fe5e8987594e9ffd1d2ca52a2f5d73eb8335243893c5d6254b5ad69269591d"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/jetbrainsmono/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=JetBrains+Mono%3Aital%2Cwght%400%2C100..800%3B1%2C100..800&display=swap",
        "upstreamRepository": "https://github.com/JetBrains/JetBrainsMono",
        "upstreamCommit": "19371302b95d218af43299bce79ddbddd0bc364d",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/jetBrainsMono/italic-100-800-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/jetBrainsMono/italic-100-800-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/jetbrainsmono/v24/tDbX2o-flEEny0FZhsfKu5WU4xD-Cw2nSGjW7BDEAQ.woff2",
          "sha256": "bdce8a4f00f61bed7141af8ac231a91be56de82f41ca2b981b34ff48359c288a",
          "bytes": 16540,
          "style": "italic",
          "weight": "100 800",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/jetBrainsMono/italic-100-800-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/jetBrainsMono/italic-100-800-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/jetbrainsmono/v24/tDbX2o-flEEny0FZhsfKu5WU4xD-CwOnSGjW7BA.woff2",
          "sha256": "6548575d68391672486bf3815a8dd9fe0ae251d1087875581ac8912d5cb52baa",
          "bytes": 42928,
          "style": "italic",
          "weight": "100 800",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/jetBrainsMono/normal-100-800-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/jetBrainsMono/normal-100-800-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/jetbrainsmono/v24/tDbV2o-flEEny0FZhsfKu5WU4xD1OwGtT0rU3BE.woff2",
          "sha256": "7db7affbce1fdee69c1ffc2641bbca289b049867f524c9d861fe35ab6670bf29",
          "bytes": 15204,
          "style": "normal",
          "weight": "100 800",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/jetBrainsMono/normal-100-800-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/jetBrainsMono/normal-100-800-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/jetbrainsmono/v24/tDbV2o-flEEny0FZhsfKu5WU4xD7OwGtT0rU.woff2",
          "sha256": "1e06740a02a443fb7f3eeda8fcaa685a0f6c620e3f01e6666e847295469ce3ad",
          "bytes": 40480,
          "style": "normal",
          "weight": "100 800",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "karla",
      "family": "Karla",
      "slug": "karla",
      "shelfId": "warm-humanists",
      "class": "sans",
      "character": "present",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "warm",
        "open",
        "human",
        "approachable"
      ],
      "artifacts": [
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "filmTvProject",
        "other"
      ],
      "lanes": [
        "reliable",
        "characterful",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not round every corner until the argument loses its spine.",
      "designer": "Jonny Pinhorn",
      "category": "SANS_SERIF",
      "dateAdded": "2012-03-14",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 200,
          "max": 800
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/karla/OFL.txt",
        "localFile": "public/fonts/type-library/karla/OFL.txt",
        "sha256": "edf2c840acb9570fe02f40721126aa0da4e4011a0030cc6dce30780569f609b6"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/karla/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Karla%3Aital%2Cwght%400%2C200..800%3B1%2C200..800&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/karla",
        "upstreamCommit": "69b25f663101efb4113dd7ed416c120dd2dce56a",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/karla/italic-200-800-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/karla/italic-200-800-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/karla/v33/qkBVXvYC6trAT7RQHtCe4ZRNkAT7MQ.woff2",
          "sha256": "e1b870a38c8390104c5fb043f34af2539d41536aea8b764e4d821ea15da65e21",
          "bytes": 15904,
          "style": "italic",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/karla/italic-200-800-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/karla/italic-200-800-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/karla/v33/qkBVXvYC6trAT7RQHt6e4ZRNkAQ.woff2",
          "sha256": "b88ce41d1d9dcd5f6a282d3eef75295792ea4aae2550f5888c9fe817ad2e89f3",
          "bytes": 32756,
          "style": "italic",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/karla/normal-200-800-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/karla/normal-200-800-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/karla/v33/qkBbXvYC6trAT7RbLtyU5rZPoAU.woff2",
          "sha256": "5b67175d95ca0044b7f9a24622f9b9db25539e6d82dcb54f8fc6d6d9cc6e7b2f",
          "bytes": 15136,
          "style": "normal",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/karla/normal-200-800-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/karla/normal-200-800-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/karla/v33/qkBbXvYC6trAT7RVLtyU5rZP.woff2",
          "sha256": "4527ba8df17f4fdc7f42ce6d9ed60e0d317133a4ab1f6c23ba3c64a502137fd0",
          "bytes": 32196,
          "style": "normal",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "lato",
      "family": "Lato",
      "slug": "lato",
      "shelfId": "warm-humanists",
      "class": "sans",
      "character": "present",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "warm",
        "open",
        "human",
        "approachable"
      ],
      "artifacts": [
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "filmTvProject",
        "other"
      ],
      "lanes": [
        "reliable",
        "characterful",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not round every corner until the argument loses its spine.",
      "designer": "Łukasz Dziedzic",
      "category": "SANS_SERIF",
      "dateAdded": "2010-12-15",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "greek-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [],
      "hasItalic": true,
      "weights": [
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/lato/OFL.txt",
        "localFile": "public/fonts/type-library/lato/OFL.txt",
        "sha256": "74ba064d03f1f1c4a952da936c3eb71866c34404916734de3cae73b34357e59e"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/lato/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Lato%3Aital%2Cwght%400%2C400%3B1%2C400%3B0%2C700%3B1%2C700&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/LatoGFVersion",
        "upstreamCommit": "080cb69711ca050d91e9c866e58df7a73095c69a",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/lato/italic-400-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/lato/italic-400-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/lato/v25/S6u8w4BMUTPHjxsAUi-qNiXg7eU0.woff2",
          "sha256": "faa2f0453abc8d16a6a13856d79be9c426ca0e1e492e1edc735d135f2772b2e2",
          "bytes": 3068,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/lato/italic-400-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/lato/italic-400-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/lato/v25/S6u8w4BMUTPHjxsAXC-qNiXg7Q.woff2",
          "sha256": "5c3360f8439a1a3f48e8b58fcb6f3a3cbaaa76488a1b846acfe1e3b623c0562f",
          "bytes": 14860,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/lato/italic-700-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/lato/italic-700-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/lato/v25/S6u_w4BMUTPHjxsI5wq_FQftx9897sxZ.woff2",
          "sha256": "948d8c34cc2a93e4cd25055841f629296c83378da5352b3653e0bc4a45382c86",
          "bytes": 3124,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/lato/italic-700-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/lato/italic-700-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/lato/v25/S6u_w4BMUTPHjxsI5wq_Gwftx9897g.woff2",
          "sha256": "4b833d8ce706a334bf1349ac9e8a424d2754604bdc412ee1ea0ae75e1379ea92",
          "bytes": 14868,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/lato/normal-400-normal-latin-ext-5.woff2",
          "publicUrl": "/fonts/type-library/lato/normal-400-normal-latin-ext-5.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/lato/v25/S6uyw4BMUTPHjxAwXiWtFCfQ7A.woff2",
          "sha256": "b85c84c655bcbba3bd628b2c1fea0fbdb5b158a9022281a2f910e82fd6da5098",
          "bytes": 2988,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/lato/normal-400-normal-latin-6.woff2",
          "publicUrl": "/fonts/type-library/lato/normal-400-normal-latin-6.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/lato/v25/S6uyw4BMUTPHjx4wXiWtFCc.woff2",
          "sha256": "d4ae5188a65370ecfe28f42293bbee8297cfd5712c6aadfdb270d48f2bcd88b0",
          "bytes": 13980,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/lato/normal-700-normal-latin-ext-7.woff2",
          "publicUrl": "/fonts/type-library/lato/normal-700-normal-latin-ext-7.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/lato/v25/S6u9w4BMUTPHh6UVSwaPGQ3q5d0N7w.woff2",
          "sha256": "78e850d569834892d3f4bdfd2084c7a7c0dc64ae4226f3231af30dae706400e2",
          "bytes": 3028,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/lato/normal-700-normal-latin-8.woff2",
          "publicUrl": "/fonts/type-library/lato/normal-700-normal-latin-8.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/lato/v25/S6u9w4BMUTPHh6UVSwiPGQ3q5d0.woff2",
          "sha256": "7a7ce1a34f3e9944fe88fc61abbc93b6db383afa2b90815fd7ccea456fbce4e5",
          "bytes": 14168,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "leagueGothic",
      "family": "League Gothic",
      "slug": "leaguegothic",
      "shelfId": "condensed-impact",
      "class": "condensed-sans",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "compressed",
        "urgent",
        "poster-like",
        "decisive"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch",
        "salesPartnership"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not use condensed width to preserve copy that should have been edited.",
      "designer": "Tyler Finck, Caroline Hadilaksono, Micah Rich",
      "category": "SANS_SERIF",
      "dateAdded": "2021-12-09",
      "subsets": [
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wdth",
          "min": 75,
          "max": 100
        }
      ],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/leaguegothic/OFL.txt",
        "localFile": "public/fonts/type-library/leagueGothic/OFL.txt",
        "sha256": "44778c339892f79188c60b7471485dd5af92c59351c7f9629a00fc625c6cae5d"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/leaguegothic/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=League+Gothic%3Awdth%4075..100&display=swap",
        "upstreamRepository": "https://github.com/sursly/league-gothic",
        "upstreamCommit": "f1d4a1c8c1db3c4a32cc13763c5fbb1776b5d478",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/leagueGothic/normal-400-75-100-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/leagueGothic/normal-400-75-100-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/leaguegothic/v13/qFdC35CBi4tvBz81xy7WG7ep0hYojnA4PLDzOA.woff2",
          "sha256": "4224b55c299576e82085aa5d190f74eb21358a3ebba242191a502951655a02ac",
          "bytes": 11108,
          "style": "normal",
          "weight": "400",
          "stretch": "75% 100%",
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/leagueGothic/normal-400-75-100-latin-2.woff2",
          "publicUrl": "/fonts/type-library/leagueGothic/normal-400-75-100-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/leaguegothic/v13/qFdC35CBi4tvBz81xy7WG7ep0hgojnA4PLA.woff2",
          "sha256": "9bfe56aa780f47e518768c73a1308868ddc7f4b461f26f65cb38c193caad84e7",
          "bytes": 18696,
          "style": "normal",
          "weight": "400",
          "stretch": "75% 100%",
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "literata",
      "family": "Literata",
      "slug": "literata",
      "shelfId": "editorial-reading",
      "class": "serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "editorial",
        "literary",
        "measured",
        "credible"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "companyCredentials",
        "other"
      ],
      "lanes": [
        "editorial",
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not use literary texture as permission for paragraphs that should be slides apart.",
      "designer": "TypeTogether",
      "category": "SERIF",
      "dateAdded": "2018-12-06",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "greek-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "opsz",
          "min": 7,
          "max": 72
        },
        {
          "tag": "wght",
          "min": 200,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/literata/OFL.txt",
        "localFile": "public/fonts/type-library/literata/OFL.txt",
        "sha256": "8742963604cd89dc81437811a850018fc03b2bfad686d7422c8235967c87614e"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/literata/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Literata%3Aital%2Copsz%2Cwght%400%2C7..72%2C200..900%3B1%2C7..72%2C200..900&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/literata",
        "upstreamCommit": "0c2761b727a1b3a7cffd313c37f0f5163dfc7a63",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/literata/italic-200-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/literata/italic-200-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/literata/v40/or3nQ6P12-iJxAIgLYT1FrkdmhHkjkotbA.woff2",
          "sha256": "dda11e3aa7cf402b8ed1237679cdb2e0ea7c55d89dfa73011f2ae647634a2065",
          "bytes": 91336,
          "style": "italic",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/literata/italic-200-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/literata/italic-200-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/literata/v40/or3nQ6P12-iJxAIgLYT1FrcdmhHkjko.woff2",
          "sha256": "07cc4f2be8b0f8a354f7dbf91078c1246d445e9b5df392becc4e25dfceea9830",
          "bytes": 113196,
          "style": "italic",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/literata/normal-200-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/literata/normal-200-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/literata/v40/or3hQ6P12-iJxAIgLYT-JrUXnTPmvks.woff2",
          "sha256": "2b511ea01010e9466367fc501ec946d6440d81360627ca212a682e1f0e2cfc32",
          "bytes": 89996,
          "style": "normal",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/literata/normal-200-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/literata/normal-200-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/literata/v40/or3hQ6P12-iJxAIgLYTwJrUXnTPm.woff2",
          "sha256": "55c10c2e8178fb96a0f39842382c2c778dade7860286f47049b574d1df15c80f",
          "bytes": 110296,
          "style": "normal",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "lora",
      "family": "Lora",
      "slug": "lora",
      "shelfId": "editorial-reading",
      "class": "serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "editorial",
        "literary",
        "measured",
        "credible"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "companyCredentials",
        "other"
      ],
      "lanes": [
        "editorial",
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not use literary texture as permission for paragraphs that should be slides apart.",
      "designer": "Cyreal",
      "category": "SERIF",
      "dateAdded": "2011-07-06",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "math",
        "menu",
        "symbols",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 400,
          "max": 700
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/lora/OFL.txt",
        "localFile": "public/fonts/type-library/lora/OFL.txt",
        "sha256": "1d9a970809ac804b582a6ce7f0ebc4e7fefcbfd7ff6299cad35ee656a21be716"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/lora/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Lora%3Aital%2Cwght%400%2C400..700%3B1%2C400..700&display=swap",
        "upstreamRepository": "https://github.com/cyrealtype/Lora-Cyrillic",
        "upstreamCommit": "403b1a66ca2e79f81d749c5299559e168591a4df",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/lora/italic-400-700-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/lora/italic-400-700-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/lora/v37/0QIhMX1D_JOuMw_LL_tLtfOm84TX.woff2",
          "sha256": "9568adfab37a5b030e75c6651f833406bf541ff7621ea8c6059249b39edb258c",
          "bytes": 21120,
          "style": "italic",
          "weight": "400 700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/lora/italic-400-700-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/lora/italic-400-700-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/lora/v37/0QIhMX1D_JOuMw_LIftLtfOm8w.woff2",
          "sha256": "3d536d49566e82a7905c8b0096758005f6616029ac08528d1f4789c1100dff6a",
          "bytes": 40648,
          "style": "italic",
          "weight": "400 700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/lora/normal-400-700-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/lora/normal-400-700-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/lora/v37/0QIvMX1D_JOuMwT7I_FMl_GW8g.woff2",
          "sha256": "55606fbc76dc232c5beb8ef584d7b4f7f76e31a9f27877112e75484356462781",
          "bytes": 20176,
          "style": "normal",
          "weight": "400 700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/lora/normal-400-700-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/lora/normal-400-700-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/lora/v37/0QIvMX1D_JOuMwr7I_FMl_E.woff2",
          "sha256": "6b102ab35aa1f2b315788bb4853434ed1e52137603bf7a3da71a682276748d45",
          "bytes": 37792,
          "style": "normal",
          "weight": "400 700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "manrope",
      "family": "Manrope",
      "slug": "manrope",
      "shelfId": "warm-humanists",
      "class": "sans",
      "character": "present",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "warm",
        "open",
        "human",
        "approachable"
      ],
      "artifacts": [
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "filmTvProject",
        "other"
      ],
      "lanes": [
        "reliable",
        "characterful",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not round every corner until the argument loses its spine.",
      "designer": "Mikhail Sharanda",
      "category": "SANS_SERIF",
      "dateAdded": "2019-10-03",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 200,
          "max": 800
        }
      ],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/manrope/OFL.txt",
        "localFile": "public/fonts/type-library/manrope/OFL.txt",
        "sha256": "e01b637272e0cbdfb240184dd98ea5cc671556d9894dae2668d92ab2c906787c"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/manrope/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Manrope%3Awght%40200..800&display=swap",
        "upstreamRepository": "https://github.com/aaronbell/manrope",
        "upstreamCommit": "6f81ebecdf65e4463b798cc07b16a4f8d5216917",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/manrope/normal-200-800-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/manrope/normal-200-800-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/manrope/v20/xn7gYHE41ni1AdIRggmxSvfedN62Zw.woff2",
          "sha256": "ce093b341d9c10658ee1eaa85c5f8042ff3307bc6ccfc5f405616eb437f0009e",
          "bytes": 15240,
          "style": "normal",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/manrope/normal-200-800-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/manrope/normal-200-800-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/manrope/v20/xn7gYHE41ni1AdIRggexSvfedN4.woff2",
          "sha256": "e310b55a7fd9677f5e3555e6c6c4d064fa1f1d24393f0ddbe217cea12a8c432f",
          "bytes": 24576,
          "style": "normal",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "martianMono",
      "family": "Martian Mono",
      "slug": "martianmono",
      "shelfId": "data-utility",
      "class": "mono",
      "character": "present",
      "roles": [
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "technical",
        "precise",
        "measured",
        "functional"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "utility"
      ],
      "oneThingNotToDo": "Do not dress ordinary prose as code to make the deck look technical.",
      "designer": "Roman Shamin, Evil Martians",
      "category": "SANS_SERIF",
      "dateAdded": "2022-11-25",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "wdth",
          "min": 75,
          "max": 112.5
        },
        {
          "tag": "wght",
          "min": 100,
          "max": 800
        }
      ],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/martianmono/OFL.txt",
        "localFile": "public/fonts/type-library/martianMono/OFL.txt",
        "sha256": "ddafd2c3f37ef1d83ef284ca63e159befd3820850c5e9eded14ca52eee92c256"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/martianmono/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Martian+Mono%3Awdth%2Cwght%4075..112.5%2C100..800&display=swap",
        "upstreamRepository": "https://github.com/evilmartians/mono",
        "upstreamCommit": "17865aac562a1a800888de6604f7251f135cf3b5",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/martianMono/normal-100-800-75-112.5-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/martianMono/normal-100-800-75-112.5-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/martianmono/v6/2V0aKIcADoYhV6w87xrTKjsSC6nIRWbh8q05.woff2",
          "sha256": "f3a5459a65588fd17966b4e7828889b440e2ae5287a44ce4809ee2b15d702ee1",
          "bytes": 24568,
          "style": "normal",
          "weight": "100 800",
          "stretch": "75% 112.5%",
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/martianMono/normal-100-800-75-112.5-latin-2.woff2",
          "publicUrl": "/fonts/type-library/martianMono/normal-100-800-75-112.5-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/martianmono/v6/2V0aKIcADoYhV6w87xrTKjsSBanIRWbh8g.woff2",
          "sha256": "debf9154726c626f203b2f9f1b1aa855123326ca5b7e88527f72dbf07659dbe5",
          "bytes": 38392,
          "style": "normal",
          "weight": "100 800",
          "stretch": "75% 112.5%",
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "merriweather",
      "family": "Merriweather",
      "slug": "merriweather",
      "shelfId": "editorial-reading",
      "class": "serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "editorial",
        "literary",
        "measured",
        "credible"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "companyCredentials",
        "other"
      ],
      "lanes": [
        "editorial",
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not use literary texture as permission for paragraphs that should be slides apart.",
      "designer": "Sorkin Type",
      "category": "SERIF",
      "dateAdded": "2011-05-11",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "opsz",
          "min": 18,
          "max": 144
        },
        {
          "tag": "wdth",
          "min": 87,
          "max": 112
        },
        {
          "tag": "wght",
          "min": 300,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/merriweather/OFL.txt",
        "localFile": "public/fonts/type-library/merriweather/OFL.txt",
        "sha256": "715bd349bfa6116f99e351e1548321dcfa25b91df65502d22ca8d624557697d2"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/merriweather/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Merriweather%3Aital%2Copsz%2Cwdth%2Cwght%400%2C18..144%2C87..112%2C300..900%3B1%2C18..144%2C87..112%2C300..900&display=swap",
        "upstreamRepository": "https://github.com/EbenSorkin/Merriweather4",
        "upstreamCommit": "e586023aa0fe1dba9a7d4ec80fa8b9e546cb7ecf",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/merriweather/italic-300-900-87-112-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/merriweather/italic-300-900-87-112-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/merriweather/v33/u-4m0qyriQwlOrhSvowK_l5-eRZAf-LVrPHpBXw.woff2",
          "sha256": "bbd60159c97d95121d74ae52d6cacc375e98a83d0118e6af3d7c387045c3c25a",
          "bytes": 268372,
          "style": "italic",
          "weight": "300 900",
          "stretch": "87% 112%",
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/merriweather/italic-300-900-87-112-latin-2.woff2",
          "publicUrl": "/fonts/type-library/merriweather/italic-300-900-87-112-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/merriweather/v33/u-4m0qyriQwlOrhSvowK_l5-eRZOf-LVrPHp.woff2",
          "sha256": "f41579d6bd2d01f0ab93bb9d47edfff4bbdd92b5aa7f094b8fc48615221ac313",
          "bytes": 372472,
          "style": "italic",
          "weight": "300 900",
          "stretch": "87% 112%",
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/merriweather/normal-300-900-87-112-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/merriweather/normal-300-900-87-112-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/merriweather/v33/u-440qyriQwlOrhSvowK_l5-ciZMdeX3rsHo.woff2",
          "sha256": "4d3bc2b280096b109afddb04745becd2d433cdf31b507c4ae8db56552f41408a",
          "bytes": 259544,
          "style": "normal",
          "weight": "300 900",
          "stretch": "87% 112%",
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/merriweather/normal-300-900-87-112-latin-4.woff2",
          "publicUrl": "/fonts/type-library/merriweather/normal-300-900-87-112-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/merriweather/v33/u-440qyriQwlOrhSvowK_l5-fCZMdeX3rg.woff2",
          "sha256": "47b58e53762332b9fdd6174ad3e581a0cd9a7a1e82784528a0589cc7aa38a5a3",
          "bytes": 368728,
          "style": "normal",
          "weight": "300 900",
          "stretch": "87% 112%",
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "newsreader",
      "family": "Newsreader",
      "slug": "newsreader",
      "shelfId": "editorial-reading",
      "class": "serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "editorial",
        "literary",
        "measured",
        "credible"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "companyCredentials",
        "other"
      ],
      "lanes": [
        "editorial",
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not use literary texture as permission for paragraphs that should be slides apart.",
      "designer": "Production Type",
      "category": "SERIF",
      "dateAdded": "2020-07-01",
      "subsets": [
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "opsz",
          "min": 6,
          "max": 72
        },
        {
          "tag": "wght",
          "min": 200,
          "max": 800
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/newsreader/OFL.txt",
        "localFile": "public/fonts/type-library/newsreader/OFL.txt",
        "sha256": "fdfad38143ec470553cae82a1e45320bdd1b9ec70415d37bd0171051d8a4ded8"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/newsreader/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Newsreader%3Aital%2Copsz%2Cwght%400%2C6..72%2C200..800%3B1%2C6..72%2C200..800&display=swap",
        "upstreamRepository": "https://github.com/productiontype/NewsReader",
        "upstreamCommit": "1ece6a8bfe5db1a2b90c76cc1fe5d3b2eed5dcf3",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/newsreader/italic-200-800-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/newsreader/italic-200-800-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/newsreader/v26/cY9CfjOCX1hbuyalUrK439vCgIhCBJWxZCPp.woff2",
          "sha256": "750e9629f56ae71980f1dde315f5bdb6c81b49b13a8fec3246a4392853aa7ccd",
          "bytes": 95412,
          "style": "italic",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/newsreader/italic-200-800-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/newsreader/italic-200-800-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/newsreader/v26/cY9CfjOCX1hbuyalUrK439vCjohCBJWxZA.woff2",
          "sha256": "a99fb127682b9af538780d21420037452197b0d37dfd273eb108f8a3665d5501",
          "bytes": 147060,
          "style": "italic",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/newsreader/normal-200-800-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/newsreader/normal-200-800-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/newsreader/v26/cY9AfjOCX1hbuyalUrK439DyjIJFJpeBZQ.woff2",
          "sha256": "cbca001188852d514d8654be7ddc97868f039bdf986b926ec5c985c117853cfd",
          "bytes": 86628,
          "style": "normal",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/newsreader/normal-200-800-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/newsreader/normal-200-800-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/newsreader/v26/cY9AfjOCX1hbuyalUrK4397yjIJFJpc.woff2",
          "sha256": "01817351be3edfc1714fe6d60ddea6a22a169a5ebd033b50c7f9495e5d9c386a",
          "bytes": 131848,
          "style": "normal",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "notoSans",
      "family": "Noto Sans",
      "slug": "notosans",
      "shelfId": "warm-humanists",
      "class": "sans",
      "character": "present",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "broad",
        "stable",
        "multilingual"
      ],
      "artifacts": [
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "filmTvProject",
        "other"
      ],
      "lanes": [
        "reliable",
        "characterful",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not round every corner until the argument loses its spine.",
      "designer": "Google",
      "category": "SANS_SERIF",
      "dateAdded": "2013-02-27",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "devanagari",
        "greek",
        "greek-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wdth",
          "min": 62.5,
          "max": 100
        },
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/notosans/OFL.txt",
        "localFile": "public/fonts/type-library/notoSans/OFL.txt",
        "sha256": "cee9892f9f0cc8fe882c9e9537ee6a89621d86ee7ceaf70b02e2b2b1c25c061a"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/notosans/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Noto+Sans%3Aital%2Cwdth%2Cwght%400%2C62.5..100%2C100..900%3B1%2C62.5..100%2C100..900&display=swap",
        "upstreamRepository": "https://github.com/notofonts/latin-greek-cyrillic",
        "upstreamCommit": "c4a321e123e4d4ff315f57f4e0adf294fe3a95be",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/notoSans/italic-100-900-62.5-100-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/notoSans/italic-100-900-62.5-100-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/notosans/v42/o-0OIpQlx3QUlC5A4PNr4ARMQ_mu72BiBLE.woff2",
          "sha256": "6ab614b98718f759e274dfa617b5261360843b574a90fa40daa034a56d2868b0",
          "bytes": 348844,
          "style": "italic",
          "weight": "100 900",
          "stretch": "62.5% 100%",
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/notoSans/italic-100-900-62.5-100-latin-2.woff2",
          "publicUrl": "/fonts/type-library/notoSans/italic-100-900-62.5-100-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/notosans/v42/o-0OIpQlx3QUlC5A4PNr4ARCQ_mu72Bi.woff2",
          "sha256": "7ad84598e83c637de48d3d425ecafa1b76ce969ac307d7713a6b86c492371899",
          "bytes": 68752,
          "style": "italic",
          "weight": "100 900",
          "stretch": "62.5% 100%",
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/notoSans/normal-100-900-62.5-100-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/notoSans/normal-100-900-62.5-100-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/notosans/v42/o-0IIpQlx3QUlC5A4PNr6zRASf6M7VBj.woff2",
          "sha256": "421e4d249fe49966566daa41ef56e6f289769ddf31c264b7d85e17aa7a249991",
          "bytes": 290392,
          "style": "normal",
          "weight": "100 900",
          "stretch": "62.5% 100%",
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/notoSans/normal-100-900-62.5-100-latin-4.woff2",
          "publicUrl": "/fonts/type-library/notoSans/normal-100-900-62.5-100-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/notosans/v42/o-0IIpQlx3QUlC5A4PNr5TRASf6M7Q.woff2",
          "sha256": "28a840bc6b70be55fe3ac10e4d2e91455dc4a84c97442a9f4b6a5c97a54d5d74",
          "bytes": 59936,
          "style": "normal",
          "weight": "100 900",
          "stretch": "62.5% 100%",
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "nunito",
      "family": "Nunito",
      "slug": "nunito",
      "shelfId": "warm-humanists",
      "class": "sans",
      "character": "present",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "warm",
        "open",
        "human",
        "approachable"
      ],
      "artifacts": [
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "filmTvProject",
        "other"
      ],
      "lanes": [
        "reliable",
        "characterful",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not round every corner until the argument loses its spine.",
      "designer": "Vernon Adams, Cyreal, Jacques Le Bailly",
      "category": "SANS_SERIF",
      "dateAdded": "2012-08-12",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 200,
          "max": 1000
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/nunito/OFL.txt",
        "localFile": "public/fonts/type-library/nunito/OFL.txt",
        "sha256": "580df76c95a1ec5ab878ceb25bb3d85c6a076804e9c970c8c6972aea775fdf65"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/nunito/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Nunito%3Aital%2Cwght%400%2C200..1000%3B1%2C200..1000&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/nunito",
        "upstreamCommit": "8c6a9bb9732545b9ed53f29ec5e1ab0ff53c4e6f",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/nunito/italic-200-1000-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/nunito/italic-200-1000-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/nunito/v32/XRXX3I6Li01BKofIMNaNRs7nczIHNHI.woff2",
          "sha256": "53d1ee66575cebe7a441ddfcfd5cacfdd757717011928bf05e9bbf7253f7a78f",
          "bytes": 39016,
          "style": "italic",
          "weight": "200 1000",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/nunito/italic-200-1000-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/nunito/italic-200-1000-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/nunito/v32/XRXX3I6Li01BKofIMNaDRs7nczIH.woff2",
          "sha256": "60ad29f2b640800bcd6a5bf81b4583a41de31b8f5153f31e5c9894430e749a8a",
          "bytes": 41744,
          "style": "italic",
          "weight": "200 1000",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/nunito/normal-200-1000-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/nunito/normal-200-1000-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/nunito/v32/XRXV3I6Li01BKofIO-aBTMnFcQIG.woff2",
          "sha256": "511ce967375fd2d924483d798f1086a533259fc675181f62944ec1176fe8786d",
          "bytes": 35464,
          "style": "normal",
          "weight": "200 1000",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/nunito/normal-200-1000-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/nunito/normal-200-1000-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/nunito/v32/XRXV3I6Li01BKofINeaBTMnFcQ.woff2",
          "sha256": "20fc9b6fc618e7c3c68d3ac750a2a5dfbceb8521675458d2cea580b5693e4798",
          "bytes": 39152,
          "style": "normal",
          "weight": "200 1000",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "onest",
      "family": "Onest",
      "slug": "onest",
      "shelfId": "warm-humanists",
      "class": "sans",
      "character": "present",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "warm",
        "open",
        "human",
        "approachable"
      ],
      "artifacts": [
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "filmTvProject",
        "other"
      ],
      "lanes": [
        "reliable",
        "characterful",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not round every corner until the argument loses its spine.",
      "designer": "Dmitri Voloshin, Andrey Kudryavtsev",
      "category": "SANS_SERIF",
      "dateAdded": "2023-09-06",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/onest/OFL.txt",
        "localFile": "public/fonts/type-library/onest/OFL.txt",
        "sha256": "071195d8806e226faeee60259c28ca67b458227af5195a73f5cfcab06e3003bc"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/onest/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Onest%3Awght%40100..900&display=swap",
        "upstreamRepository": "https://github.com/simpals/onest",
        "upstreamCommit": "f18c06a14512e43a6191849278d6f07fdaf347d6",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/onest/normal-100-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/onest/normal-100-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/onest/v9/gNMKW3F-SZuj7xmR-HYoEoeyxMI.woff2",
          "sha256": "b796cb9f9b4b70ba743f9139f8f7711e9bb9fcbb30c9cefdc6538344987e56e2",
          "bytes": 15940,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/onest/normal-100-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/onest/normal-100-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/onest/v9/gNMKW3F-SZuj7xmf-HYoEoey.woff2",
          "sha256": "3b422208ffa279f8d2584584b443b3acf6b404c8a046763b7cbf7d7c0e66bfb4",
          "bytes": 32256,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "oswald",
      "family": "Oswald",
      "slug": "oswald",
      "shelfId": "condensed-impact",
      "class": "condensed-sans",
      "character": "expressive",
      "roles": [
        "display",
        "utility"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "compressed",
        "urgent",
        "poster-like",
        "decisive"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch",
        "salesPartnership"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not use condensed width to preserve copy that should have been edited.",
      "designer": "Vernon Adams, Kalapi Gajjar, Cyreal",
      "category": "SANS_SERIF",
      "dateAdded": "2012-02-29",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 200,
          "max": 700
        }
      ],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/oswald/OFL.txt",
        "localFile": "public/fonts/type-library/oswald/OFL.txt",
        "sha256": "0fd731a904b729a4e02eaf5e8ebd06783edd9abe400e8882760160230675b652"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/oswald/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Oswald%3Awght%40200..700&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/OswaldFont",
        "upstreamCommit": "89795261ac9eeb9aa8cd99f43982c4e4b0e53261",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/oswald/normal-200-700-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/oswald/normal-200-700-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/oswald/v57/TK3iWkUHHAIjg752Fz8Gl-1PK62t.woff2",
          "sha256": "387bb9ea916076d47014c0db1c750b482547647f2ab9ad73ae585928377d12fa",
          "bytes": 24048,
          "style": "normal",
          "weight": "200 700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/oswald/normal-200-700-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/oswald/normal-200-700-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/oswald/v57/TK3iWkUHHAIjg752GT8Gl-1PKw.woff2",
          "sha256": "c36937da4c39049704f1def587f7837a24ad52d3bfd2d27d3b6eb9f4220b2e3a",
          "bytes": 28456,
          "style": "normal",
          "weight": "200 700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "outfit",
      "family": "Outfit",
      "slug": "outfit",
      "shelfId": "geometric-voices",
      "class": "sans",
      "character": "expressive",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "sparse",
        "moderate",
        "varied"
      ],
      "tones": [
        "graphic",
        "contemporary",
        "confident",
        "constructed"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "startupInvestor",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not let the display face colonize paragraphs, labels and footnotes.",
      "designer": "Smartsheet Inc, Rodrigo Fuenzalida",
      "category": "SANS_SERIF",
      "dateAdded": "2021-09-28",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/outfit/OFL.txt",
        "localFile": "public/fonts/type-library/outfit/OFL.txt",
        "sha256": "c676351bf8576b9aba743cd5eaa8c0e7ee0d51f805d720447b4df4ddb6a2e416"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/outfit/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Outfit%3Awght%40100..900&display=swap",
        "upstreamRepository": "https://github.com/Outfitio/Outfit-Fonts",
        "upstreamCommit": "902773808eb372f70fb34e8946dd1ffe604efc79",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/outfit/normal-100-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/outfit/normal-100-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/outfit/v15/QGYvz_MVcBeNP4NJuktqUYLkn8BJ.woff2",
          "sha256": "9e38b3f1575daba3435ef09d33a202585ed5bd204bd0a8c744955c750c2b9091",
          "bytes": 14760,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/outfit/normal-100-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/outfit/normal-100-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/outfit/v15/QGYvz_MVcBeNP4NJtEtqUYLknw.woff2",
          "sha256": "92684e4acde79ef07758cd09380b7e01e9824d8b061eddeda046f78c166d7b12",
          "bytes": 32228,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "petrona",
      "family": "Petrona",
      "slug": "petrona",
      "shelfId": "sturdy-serifs",
      "class": "sturdy-serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "sturdy",
        "grounded",
        "substantial",
        "practical"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "editorial",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not mistake weight for authority; hierarchy still has to do the work.",
      "designer": "Ringo R. Seeber",
      "category": "SERIF",
      "dateAdded": "2020-07-15",
      "subsets": [
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/petrona/OFL.txt",
        "localFile": "public/fonts/type-library/petrona/OFL.txt",
        "sha256": "a889ff77b75be8bcd1456ff147eb9dac647f3eb217fad50fb4877496884f6dcb"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/petrona/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Petrona%3Aital%2Cwght%400%2C100..900%3B1%2C100..900&display=swap",
        "upstreamRepository": "https://github.com/RingoSeeber/Petrona",
        "upstreamCommit": "03d4b6dd8af6ecf3a51d3b126bd64e491cb01d18",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/petrona/italic-100-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/petrona/italic-100-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/petrona/v38/mtG44_NXL7bZo9XXgXdouUMV8ia-FnZE.woff2",
          "sha256": "f7b6af8841620b2bedb20d710cd9ff0d5996297b239abc40e18c9558803eb0a0",
          "bytes": 30212,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/petrona/italic-100-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/petrona/italic-100-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/petrona/v38/mtG44_NXL7bZo9XXgXdot0MV8ia-Fg.woff2",
          "sha256": "721ffa0637b06efc8635a7577c75107aef79bb2980e56f5020cea24c3d991a66",
          "bytes": 39516,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/petrona/normal-100-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/petrona/normal-100-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/petrona/v38/mtG64_NXL7bZo9XXgXxYtUkS0CSOFw.woff2",
          "sha256": "f07e4ecdb694535151871c334da4fea1056b2ac0779377cddba35d88f92e9920",
          "bytes": 28388,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/petrona/normal-100-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/petrona/normal-100-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/petrona/v38/mtG64_NXL7bZo9XXgXJYtUkS0CQ.woff2",
          "sha256": "db840dc4f3bf5b3a12539e4603dee039e83018fb4a4d3f94071fe4f1e72add83",
          "bytes": 35964,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "playfairDisplay",
      "family": "Playfair Display",
      "slug": "playfairdisplay",
      "shelfId": "expressive-serif",
      "class": "display-serif",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "dramatic",
        "tactile",
        "authored",
        "cinematic"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "editorial",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not turn every sentence into a costume change.",
      "designer": "Claus Eggers Sørensen",
      "category": "SERIF",
      "dateAdded": "2011-11-16",
      "subsets": [
        "cyrillic",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 400,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/playfairdisplay/OFL.txt",
        "localFile": "public/fonts/type-library/playfairDisplay/OFL.txt",
        "sha256": "566be814f8e96e93dfa16101331557eb6b5467e9e03f627c0910fe93ca12300e"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/playfairdisplay/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Playfair+Display%3Aital%2Cwght%400%2C400..900%3B1%2C400..900&display=swap",
        "upstreamRepository": "https://github.com/clauseggers/Playfair",
        "upstreamCommit": "80a334101928546b04fa9e709ad4b2f11f8a9e10",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/playfairDisplay/italic-400-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/playfairDisplay/italic-400-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/playfairdisplay/v40/nuFkD-vYSZviVYUb_rj3ij__anPXDTnojEk7yRZrPJ-M.woff2",
          "sha256": "4d6a56168573c731f483ecfbaa468d38a674be49335160476bfa1eaf7c399fbb",
          "bytes": 23332,
          "style": "italic",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/playfairDisplay/italic-400-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/playfairDisplay/italic-400-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/playfairdisplay/v40/nuFkD-vYSZviVYUb_rj3ij__anPXDTnogkk7yRZrPA.woff2",
          "sha256": "c68530044e7c4ce6cd3c1c239d0a93be71af53821574714f83e1380d8b393d14",
          "bytes": 38888,
          "style": "italic",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/playfairDisplay/normal-400-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/playfairDisplay/normal-400-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/playfairdisplay/v40/nuFiD-vYSZviVYUb_rj3ij__anPXDTLYgEM86xRbPQ.woff2",
          "sha256": "5628567856d60d714e7a35bcac9e3de08b336d63b12138f61b970990a1ee9547",
          "bytes": 20980,
          "style": "normal",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/playfairDisplay/normal-400-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/playfairDisplay/normal-400-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/playfairdisplay/v40/nuFiD-vYSZviVYUb_rj3ij__anPXDTzYgEM86xQ.woff2",
          "sha256": "5d91eb5d522a03081946c44c8ca17c902230dfed5f0f9b5014262135d47b15b2",
          "bytes": 38460,
          "style": "normal",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "plusJakartaSans",
      "family": "Plus Jakarta Sans",
      "slug": "plusjakartasans",
      "shelfId": "warm-humanists",
      "class": "sans",
      "character": "present",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "warm",
        "open",
        "human",
        "approachable"
      ],
      "artifacts": [
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "filmTvProject",
        "other"
      ],
      "lanes": [
        "reliable",
        "characterful",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not round every corner until the argument loses its spine.",
      "designer": "Tokotype",
      "category": "SANS_SERIF",
      "dateAdded": "2022-03-24",
      "subsets": [
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 200,
          "max": 800
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/plusjakartasans/OFL.txt",
        "localFile": "public/fonts/type-library/plusJakartaSans/OFL.txt",
        "sha256": "995c7199cab65954f545996326755daee7b63cc6b42b06c13da1f9502ab08a99"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/plusjakartasans/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans%3Aital%2Cwght%400%2C200..800%3B1%2C200..800&display=swap",
        "upstreamRepository": "https://github.com/tokotype/PlusJakartaSans",
        "upstreamCommit": "18d1cd2f7ea10481919d2f05c1f7064b7307fc26",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/plusJakartaSans/italic-200-800-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/plusJakartaSans/italic-200-800-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/plusjakartasans/v12/LDIuaomQNQcsA88c7O9yZ4KMCoOg4Koz4yCqhNnZR-AHYA.woff2",
          "sha256": "00b9920a831136ed75903abbc3011a69071dca7397493e944576fa70da89b0e9",
          "bytes": 23140,
          "style": "italic",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/plusJakartaSans/italic-200-800-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/plusJakartaSans/italic-200-800-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/plusjakartasans/v12/LDIuaomQNQcsA88c7O9yZ4KMCoOg4Koz4y6qhNnZR-A.woff2",
          "sha256": "f7f3c763fa6749357a187418d736aab5b2acdd1d0a83a408631382bcfd80d141",
          "bytes": 29524,
          "style": "italic",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/plusJakartaSans/normal-200-800-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/plusJakartaSans/normal-200-800-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/plusjakartasans/v12/LDIoaomQNQcsA88c7O9yZ4KMCoOg4Ko40yygg_vbd-E.woff2",
          "sha256": "0303e02b53b0298fb26a0193941a2e8754f0f9a9fce50d90b178d8da3424873f",
          "bytes": 21688,
          "style": "normal",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/plusJakartaSans/normal-200-800-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/plusJakartaSans/normal-200-800-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/plusjakartasans/v12/LDIoaomQNQcsA88c7O9yZ4KMCoOg4Ko20yygg_vb.woff2",
          "sha256": "cd8db90cd950e26bc8761f65d323588bd5cd112d326d6d322bc7c8ea86771215",
          "bytes": 27272,
          "style": "normal",
          "weight": "200 800",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "publicSans",
      "family": "Public Sans",
      "slug": "publicsans",
      "shelfId": "clear-workhorses",
      "class": "sans",
      "character": "quiet",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "clear",
        "plainspoken",
        "rigorous",
        "calm"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not confuse neutrality with an excuse to make every slide identical.",
      "designer": "USWDS, Dan Williams, Pablo Impallari, Rodrigo Fuenzalida",
      "category": "SANS_SERIF",
      "dateAdded": "2019-06-07",
      "subsets": [
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/publicsans/OFL.txt",
        "localFile": "public/fonts/type-library/publicSans/OFL.txt",
        "sha256": "157a9e77f7580246e97c769490e2e977ae94399f9d30f4556015c41fe8c28bac"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/publicsans/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Public+Sans%3Aital%2Cwght%400%2C100..900%3B1%2C100..900&display=swap",
        "upstreamRepository": "https://github.com/uswds/public-sans",
        "upstreamCommit": "c7923167a592d941646f99fb7b5fba17aa7d69e1",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/publicSans/italic-100-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/publicSans/italic-100-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/publicsans/v21/ijwTs572Xtc6ZYQws9YVwnNDTJLax8s3JimW3w.woff2",
          "sha256": "bbf89d33a9f5a28aee1b31458e66dacb84a64706690655b9853a04bcdf2923f0",
          "bytes": 19292,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/publicSans/italic-100-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/publicSans/italic-100-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/publicsans/v21/ijwTs572Xtc6ZYQws9YVwnNDTJzax8s3Jik.woff2",
          "sha256": "03c56a19a5ee626ef9007edcfca457e57eda0f5d4c8df0f713fbeb6e155b1b00",
          "bytes": 28356,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/publicSans/normal-100-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/publicSans/normal-100-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/publicsans/v21/ijwRs572Xtc6ZYQws9YVwnNIfJ7QwOk1Fig.woff2",
          "sha256": "1c8a26c0ed4312dacc36670714794c9f4b4a0972ccb45f2936646bd8d444d5f8",
          "bytes": 18372,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/publicSans/normal-100-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/publicSans/normal-100-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/publicsans/v21/ijwRs572Xtc6ZYQws9YVwnNGfJ7QwOk1.woff2",
          "sha256": "c1b6da516e0062e9c2f341b3a51dd2d621d946da72f06c6cfe05fd9d2dd8622d",
          "bytes": 26636,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "redHatMono",
      "family": "Red Hat Mono",
      "slug": "redhatmono",
      "shelfId": "data-utility",
      "class": "mono",
      "character": "present",
      "roles": [
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "technical",
        "precise",
        "measured",
        "functional"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "utility"
      ],
      "oneThingNotToDo": "Do not dress ordinary prose as code to make the deck look technical.",
      "designer": "MCKL",
      "category": "SANS_SERIF",
      "dateAdded": "2021-06-10",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 300,
          "max": 700
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/redhatmono/OFL.txt",
        "localFile": "public/fonts/type-library/redHatMono/OFL.txt",
        "sha256": "435fbfb7e66988b2a06686a4cb966faec733f35d8fe100a1601573c27f3e0bb8"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/redhatmono/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Red+Hat+Mono%3Aital%2Cwght%400%2C300..700%3B1%2C300..700&display=swap",
        "upstreamRepository": "https://github.com/RedHatOfficial/RedHatFont",
        "upstreamCommit": "32287097803f6c58136b60bc7a4a594a7fcbd689",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/redHatMono/italic-300-700-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/redHatMono/italic-300-700-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/redhatmono/v16/jVyT7nDnA2uf2zVvFAhhzEsUXdxe1gjCexXweZQ.woff2",
          "sha256": "7661f6503e2df49cbb284bbb73b405489b4f68b432772807898261c838caceba",
          "bytes": 12724,
          "style": "italic",
          "weight": "300 700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/redHatMono/italic-300-700-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/redHatMono/italic-300-700-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/redhatmono/v16/jVyT7nDnA2uf2zVvFAhhzEsUXdxQ1gjCexXw.woff2",
          "sha256": "c9b2d3ab6657c6121f2ba36c7c764a94748110018a76c435bbc4cb08a209aeba",
          "bytes": 24208,
          "style": "italic",
          "weight": "300 700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/redHatMono/normal-300-700-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/redHatMono/normal-300-700-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/redhatmono/v16/jVyN7nDnA2uf2zVvFAhhzEsUVuxS3A_geSXx.woff2",
          "sha256": "9ee1765f5f8ed0efe8755c60aadd384ef817de7d3132d8e0537c3ecd068aed86",
          "bytes": 11736,
          "style": "normal",
          "weight": "300 700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/redHatMono/normal-300-700-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/redHatMono/normal-300-700-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/redhatmono/v16/jVyN7nDnA2uf2zVvFAhhzEsUWOxS3A_geQ.woff2",
          "sha256": "9914ffa64379b1ff4d69d246db13d7d84acceed0872b3a29008ae55020a8ff75",
          "bytes": 22392,
          "style": "normal",
          "weight": "300 700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "robotoCondensed",
      "family": "Roboto Condensed",
      "slug": "robotocondensed",
      "shelfId": "condensed-impact",
      "class": "condensed-sans",
      "character": "expressive",
      "roles": [
        "display",
        "utility"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "compressed",
        "urgent",
        "poster-like",
        "decisive"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch",
        "salesPartnership"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not use condensed width to preserve copy that should have been edited.",
      "designer": "Christian Robertson",
      "category": "SANS_SERIF",
      "dateAdded": "2023-07-28",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "greek-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/robotocondensed/OFL.txt",
        "localFile": "public/fonts/type-library/robotoCondensed/OFL.txt",
        "sha256": "0e4cc6ece88573545be2ed25835363662a6182ba4a4c1b5c8feda52add30e8a6"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/robotocondensed/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Roboto+Condensed%3Aital%2Cwght%400%2C100..900%3B1%2C100..900&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/roboto-classic",
        "upstreamCommit": "8aa699a9a715be7ecf6be41171e2851a580f0fb8",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/robotoCondensed/italic-100-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/robotoCondensed/italic-100-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/robotocondensed/v31/ieVj2ZhZI2eCN5jzbjEETS9weq8-19eLAQM9QPFUex17.woff2",
          "sha256": "2448f57125c020d94dc240b32d2ae6ebc20951ff0b42d24b81c87828e9cde5be",
          "bytes": 32168,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/robotoCondensed/italic-100-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/robotoCondensed/italic-100-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/robotocondensed/v31/ieVj2ZhZI2eCN5jzbjEETS9weq8-19eLDwM9QPFUew.woff2",
          "sha256": "f0b2892a60e5701036cf0e142170cf698fbdf3a0d323fc57011e849ef5aa5d78",
          "bytes": 51496,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/robotoCondensed/normal-100-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/robotoCondensed/normal-100-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/robotocondensed/v31/ieVl2ZhZI2eCN5jzbjEETS9weq8-19y7DQk6YvNkeg.woff2",
          "sha256": "a0116a788a1915a01006334bf8ae893967eb65ae229da985c5095ddde5f6a977",
          "bytes": 28908,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/robotoCondensed/normal-100-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/robotoCondensed/normal-100-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/robotocondensed/v31/ieVl2ZhZI2eCN5jzbjEETS9weq8-19K7DQk6YvM.woff2",
          "sha256": "718ced55c5d8e207d6d14b1765fe6cf5886882834f45cc0ad23283cd210f9a96",
          "bytes": 46080,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "robotoMono",
      "family": "Roboto Mono",
      "slug": "robotomono",
      "shelfId": "data-utility",
      "class": "mono",
      "character": "present",
      "roles": [
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "technical",
        "precise",
        "measured",
        "functional"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "utility"
      ],
      "oneThingNotToDo": "Do not dress ordinary prose as code to make the deck look technical.",
      "designer": "Christian Robertson",
      "category": "MONOSPACE",
      "dateAdded": "2015-05-13",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 700
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/robotomono/OFL.txt",
        "localFile": "public/fonts/type-library/robotoMono/OFL.txt",
        "sha256": "50ab8dd54680d3473f649c9db86fece88434d097c7834475c1c72d2f8c429215"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/robotomono/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Roboto+Mono%3Aital%2Cwght%400%2C100..700%3B1%2C100..700&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/RobotoMono",
        "upstreamCommit": "111eb14e367888c9374da4da0b018e72cf8ac46d",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/robotoMono/italic-100-700-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/robotoMono/italic-100-700-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/robotomono/v31/L0x7DF4xlVMF-BfR8bXMIjhOm3OWWpCBC10HFw.woff2",
          "sha256": "b983965f0899ebc79a826adc2a527fc8ffe81aa204dcdca1a355fffdb0b3a6c9",
          "bytes": 24356,
          "style": "italic",
          "weight": "100 700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/robotoMono/italic-100-700-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/robotoMono/italic-100-700-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/robotomono/v31/L0x7DF4xlVMF-BfR8bXMIjhOm32WWpCBC10.woff2",
          "sha256": "52cf6d1b27b1fd0ee92ac6fb753f046fcb0a7e9bf60b1c477744db09e2c48fc9",
          "bytes": 35240,
          "style": "italic",
          "weight": "100 700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/robotoMono/normal-100-700-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/robotoMono/normal-100-700-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/robotomono/v31/L0x5DF4xlVMF-BfR8bXMIjhFq3-cXbKDO1w.woff2",
          "sha256": "2cb74c78294bf69bb4c40e56d703014eecb0776df9a23418be836392fc7fdf89",
          "bytes": 22868,
          "style": "normal",
          "weight": "100 700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/robotoMono/normal-100-700-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/robotoMono/normal-100-700-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/robotomono/v31/L0x5DF4xlVMF-BfR8bXMIjhLq3-cXbKD.woff2",
          "sha256": "2ed6ac9efae6d21f51b2946176a0eef79a4043d643f9ac976e66d7fc4d57803a",
          "bytes": 32752,
          "style": "normal",
          "weight": "100 700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "robotoSerif",
      "family": "Roboto Serif",
      "slug": "robotoserif",
      "shelfId": "sturdy-serifs",
      "class": "sturdy-serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "sturdy",
        "grounded",
        "substantial",
        "practical"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "editorial",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not mistake weight for authority; hierarchy still has to do the work.",
      "designer": "Commercial Type, Greg Gazdowicz",
      "category": "SERIF",
      "dateAdded": "2022-02-10",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "GRAD",
          "min": -50,
          "max": 100
        },
        {
          "tag": "opsz",
          "min": 8,
          "max": 144
        },
        {
          "tag": "wdth",
          "min": 50,
          "max": 150
        },
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/robotoserif/OFL.txt",
        "localFile": "public/fonts/type-library/robotoSerif/OFL.txt",
        "sha256": "34dbfbb43e0b4fdeef445d77b9ac0b988e5ad7a9bbf16808c97b66c66d51f553"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/robotoserif/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Roboto+Serif%3Aital%2Copsz%2Cwdth%2Cwght%400%2C8..144%2C50..150%2C100..900%3B1%2C8..144%2C50..150%2C100..900&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/roboto-serif",
        "upstreamCommit": "1ecc2513e8215b569246a5802f18aa4b0e1d67a5",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/robotoSerif/italic-100-900-50-150-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/robotoSerif/italic-100-900-50-150-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/robotoserif/v17/R70OjywflP6FLr3gZx7K8UyEVQnyR1E7VN-f51xYuGC6eLtQy4F4dUb1.woff2",
          "sha256": "1124ca8b4d4cf1424f647deac5ca374a229fe9c0664458b4dce3a04f39a03907",
          "bytes": 331308,
          "style": "italic",
          "weight": "100 900",
          "stretch": "50% 150%",
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/robotoSerif/italic-100-900-50-150-latin-2.woff2",
          "publicUrl": "/fonts/type-library/robotoSerif/italic-100-900-50-150-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/robotoserif/v17/R70OjywflP6FLr3gZx7K8UyEVQnyR1E7VN-f51xYuGC6drtQy4F4dQ.woff2",
          "sha256": "da8a00d1617f23548d886f3950f755f83b210ce6a53b9ab6bc250aaca2740163",
          "bytes": 437256,
          "style": "italic",
          "weight": "100 900",
          "stretch": "50% 150%",
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/robotoSerif/normal-100-900-50-150-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/robotoSerif/normal-100-900-50-150-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/robotoserif/v17/R70IjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYqGmKdLFX6YNIdA.woff2",
          "sha256": "2f3824da7a834b180aaf90a7c4b0f4d72d0a3cddf3f3dc710c1410de95cac412",
          "bytes": 310720,
          "style": "normal",
          "weight": "100 900",
          "stretch": "50% 150%",
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/robotoSerif/normal-100-900-50-150-latin-4.woff2",
          "publicUrl": "/fonts/type-library/robotoSerif/normal-100-900-50-150-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/robotoserif/v17/R70IjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYqGeKdLFX6YM.woff2",
          "sha256": "29dd83113ccb981163a5a2bf2691ba9c755b56396c65a8591e1848ddd1a8a950",
          "bytes": 379184,
          "style": "normal",
          "weight": "100 900",
          "stretch": "50% 150%",
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "sora",
      "family": "Sora",
      "slug": "sora",
      "shelfId": "geometric-voices",
      "class": "sans",
      "character": "expressive",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "sparse",
        "moderate",
        "varied"
      ],
      "tones": [
        "graphic",
        "contemporary",
        "confident",
        "constructed"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "startupInvestor",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not let the display face colonize paragraphs, labels and footnotes.",
      "designer": "Jonathan Barnbrook, Julián Moncada",
      "category": "SANS_SERIF",
      "dateAdded": "2020-06-10",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 800
        }
      ],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/sora/OFL.txt",
        "localFile": "public/fonts/type-library/sora/OFL.txt",
        "sha256": "ba0b9729c9428ba79a0459ab8ec575791b51509dbec213e383d0316d37fec299"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/sora/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Sora%3Awght%40100..800&display=swap",
        "upstreamRepository": "https://github.com/sora-xor/sora-font",
        "upstreamCommit": "7f9a9c5d0ccd1c099cfac420aa27133df1c5fdc4",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/sora/normal-100-800-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/sora/normal-100-800-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/sora/v17/xMQbuFFYT72XzQspDqW1KX7wmA.woff2",
          "sha256": "df4fca18912e29202b16286ab514798de8357c416b5e1f2dd31703994bec7a78",
          "bytes": 15556,
          "style": "normal",
          "weight": "100 800",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/sora/normal-100-800-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/sora/normal-100-800-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/sora/v17/xMQbuFFYT72XzQUpDqW1KX4.woff2",
          "sha256": "d2909123a6a8ed2f928055f002c32f63ee93496b470c1a344873f955111fca53",
          "bytes": 33672,
          "style": "normal",
          "weight": "100 800",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "sourceCodePro",
      "family": "Source Code Pro",
      "slug": "sourcecodepro",
      "shelfId": "data-utility",
      "class": "mono",
      "character": "present",
      "roles": [
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "technical",
        "precise",
        "measured",
        "functional"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "utility"
      ],
      "oneThingNotToDo": "Do not dress ordinary prose as code to make the deck look technical.",
      "designer": "Paul D. Hunt",
      "category": "MONOSPACE",
      "dateAdded": "2012-09-20",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "greek-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 200,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/sourcecodepro/OFL.txt",
        "localFile": "public/fonts/type-library/sourceCodePro/OFL.txt",
        "sha256": "cb30d3086a8b3ce0b9e3690bf48d6620402b61160bc658076f95180ccd9e9dae"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/sourcecodepro/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Source+Code+Pro%3Aital%2Cwght%400%2C200..900%3B1%2C200..900&display=swap",
        "upstreamRepository": "https://github.com/adobe-fonts/source-code-pro",
        "upstreamCommit": "803b7e23ec97ae58b6232ea76519a76d428ba268",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/sourceCodePro/italic-200-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/sourceCodePro/italic-200-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/sourcecodepro/v31/HI_QiYsKILxRpg3hIP6sJ7fM7PqlONvalMIFxGC8NAU.woff2",
          "sha256": "fab1090d98e8b47a5fb26f3a3fd558bb77e6e5774c96dbb3eae22f61cd4589be",
          "bytes": 33948,
          "style": "italic",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/sourceCodePro/italic-200-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/sourceCodePro/italic-200-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/sourcecodepro/v31/HI_QiYsKILxRpg3hIP6sJ7fM7PqlONvUlMIFxGC8.woff2",
          "sha256": "68b55e7814164bdc142e6eea21152d9c682d13b35a537bdba13dc3bc2a2c422f",
          "bytes": 22452,
          "style": "italic",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/sourceCodePro/normal-200-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/sourceCodePro/normal-200-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/sourcecodepro/v31/HI_SiYsKILxRpg3hIP6sJ7fM7PqlM-vWnsUnxlC9.woff2",
          "sha256": "1954e099c19e7e8eb50d644339b34552351d8851da8d6830158be848990a3290",
          "bytes": 33604,
          "style": "normal",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/sourceCodePro/normal-200-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/sourceCodePro/normal-200-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/sourcecodepro/v31/HI_SiYsKILxRpg3hIP6sJ7fM7PqlPevWnsUnxg.woff2",
          "sha256": "2c935ccea0efa74f1d034628790a2aebfe2ccb6f5d60e8f5b224366066e10188",
          "bytes": 21968,
          "style": "normal",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "sourceSans3",
      "family": "Source Sans 3",
      "slug": "sourcesans3",
      "shelfId": "clear-workhorses",
      "class": "sans",
      "character": "quiet",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "clear",
        "plainspoken",
        "rigorous",
        "calm"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not confuse neutrality with an excuse to make every slide identical.",
      "designer": "Paul D. Hunt",
      "category": "SANS_SERIF",
      "dateAdded": "2021-09-17",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "greek-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 200,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/sourcesans3/OFL.txt",
        "localFile": "public/fonts/type-library/sourceSans3/OFL.txt",
        "sha256": "09746787287a289323b0ec3cff4d1a4a801331b82b7207c1e186f5d26619a392"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/sourcesans3/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Source+Sans+3%3Aital%2Cwght%400%2C200..900%3B1%2C200..900&display=swap",
        "upstreamRepository": "https://github.com/adobe-fonts/source-sans",
        "upstreamCommit": "272b22b02e097e8eff1372111f88b5ab6063499f",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/sourceSans3/italic-200-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/sourceSans3/italic-200-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/sourcesans3/v19/nwpMtKy2OAdR1K-IwhWudF-R3woqaeLYxnV18JRx.woff2",
          "sha256": "daff22b9d8482f797b1ffb84f253cad6f7d61ca35afa7a46bba0884ee9e31998",
          "bytes": 59368,
          "style": "italic",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/sourceSans3/italic-200-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/sourceSans3/italic-200-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/sourcesans3/v19/nwpMtKy2OAdR1K-IwhWudF-R3woqZ-LYxnV18A.woff2",
          "sha256": "dba77455b9c188678eb9103c4b6b7fb8105968c3a4b5828204c350f6781c1638",
          "bytes": 28464,
          "style": "italic",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/sourceSans3/normal-200-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/sourceSans3/normal-200-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/sourcesans3/v19/nwpStKy2OAdR1K-IwhWudF-R3wEaZejf5HdF8Q.woff2",
          "sha256": "ed3571ea9ff752f1c846f1c9ad2b0006de42f478a2db9163a74db0729a4eb281",
          "bytes": 60048,
          "style": "normal",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/sourceSans3/normal-200-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/sourceSans3/normal-200-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/sourcesans3/v19/nwpStKy2OAdR1K-IwhWudF-R3w8aZejf5Hc.woff2",
          "sha256": "ac057a5593cbe3df0d2585da5dd5f33b8efa84aa30550c710fe061b37fc5c54b",
          "bytes": 28792,
          "style": "normal",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "sourceSerif4",
      "family": "Source Serif 4",
      "slug": "sourceserif4",
      "shelfId": "editorial-reading",
      "class": "serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "editorial",
        "literary",
        "measured",
        "credible"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "companyCredentials",
        "other"
      ],
      "lanes": [
        "editorial",
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not use literary texture as permission for paragraphs that should be slides apart.",
      "designer": "Frank Grießhammer",
      "category": "SERIF",
      "dateAdded": "2021-11-16",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "opsz",
          "min": 8,
          "max": 60
        },
        {
          "tag": "wght",
          "min": 200,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/sourceserif4/OFL.txt",
        "localFile": "public/fonts/type-library/sourceSerif4/OFL.txt",
        "sha256": "5f94c3fd3a23131a417ab5a0c8452de57e70c3cfb9f604d88241f7065ebf9fd9"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/sourceserif4/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Source+Serif+4%3Aital%2Copsz%2Cwght%400%2C8..60%2C200..900%3B1%2C8..60%2C200..900&display=swap",
        "upstreamRepository": "https://github.com/adobe-fonts/source-serif",
        "upstreamCommit": "b3980ade53bb3d023a0006076d05349236b309b1",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/sourceSerif4/italic-200-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/sourceSerif4/italic-200-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/sourceserif4/v14/vEFK2_tTDB4M7-auWDN0ahZJW1gewtu_WpzEpMvsfA.woff2",
          "sha256": "513549ab98be3ff8f5dfbc43e9782562bb059ec966c9259c1aeab99193e39426",
          "bytes": 110416,
          "style": "italic",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/sourceSerif4/italic-200-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/sourceSerif4/italic-200-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/sourceserif4/v14/vEFK2_tTDB4M7-auWDN0ahZJW1gewtW_WpzEpMs.woff2",
          "sha256": "011e0ca2bd14c5dff94aa4c61121b8d057b95dbdbb2af621b175fed1059cfd5e",
          "bytes": 129940,
          "style": "italic",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/sourceSerif4/normal-200-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/sourceSerif4/normal-200-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/sourceserif4/v14/vEFI2_tTDB4M7-auWDN0ahZJW1gV8te1Xb7GlMo.woff2",
          "sha256": "a0cd390d017200f91327781204458ff918999584bece8902497ba6c08472178d",
          "bytes": 100772,
          "style": "normal",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/sourceSerif4/normal-200-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/sourceSerif4/normal-200-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/sourceserif4/v14/vEFI2_tTDB4M7-auWDN0ahZJW1gb8te1Xb7G.woff2",
          "sha256": "2a24bad466f09b88b8e9cbc488bf774117c912e66374c57bf4716855849143f8",
          "bytes": 122168,
          "style": "normal",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "spaceGrotesk",
      "family": "Space Grotesk",
      "slug": "spacegrotesk",
      "shelfId": "geometric-voices",
      "class": "sans",
      "character": "expressive",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "sparse",
        "moderate",
        "varied"
      ],
      "tones": [
        "graphic",
        "contemporary",
        "confident",
        "constructed"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "startupInvestor",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not let the display face colonize paragraphs, labels and footnotes.",
      "designer": "Florian Karsten",
      "category": "SANS_SERIF",
      "dateAdded": "2020-10-07",
      "subsets": [
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 300,
          "max": 700
        }
      ],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/spacegrotesk/OFL.txt",
        "localFile": "public/fonts/type-library/spaceGrotesk/OFL.txt",
        "sha256": "564ce565c371c5e5bbf286006565a7c9aa55a9f56e7ca58d56e05d649dd61a72"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/spacegrotesk/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Space+Grotesk%3Awght%40300..700&display=swap",
        "upstreamRepository": "https://github.com/floriankarsten/space-grotesk",
        "upstreamCommit": "03507d024a01282884232081fc6011c09ff4e849",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/spaceGrotesk/normal-300-700-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/spaceGrotesk/normal-300-700-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spacegrotesk/v22/V8mDoQDjQSkFtoMM3T6r8E7mPb94C_k3HqUtEw.woff2",
          "sha256": "054c266fbb441ee059365dba0885d206f67ca05b375de869b88e02ebfccc9b9d",
          "bytes": 18924,
          "style": "normal",
          "weight": "300 700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/spaceGrotesk/normal-300-700-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/spaceGrotesk/normal-300-700-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spacegrotesk/v22/V8mDoQDjQSkFtoMM3T6r8E7mPbF4C_k3HqU.woff2",
          "sha256": "a0d054c4af557de20afd6ca59f47ab353bcaec49c63ff04b6c9d39d0f8910557",
          "bytes": 22320,
          "style": "normal",
          "weight": "300 700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "spaceMono",
      "family": "Space Mono",
      "slug": "spacemono",
      "shelfId": "data-utility",
      "class": "mono",
      "character": "present",
      "roles": [
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "technical",
        "precise",
        "measured",
        "functional"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "utility"
      ],
      "oneThingNotToDo": "Do not dress ordinary prose as code to make the deck look technical.",
      "designer": "Colophon Foundry",
      "category": "MONOSPACE",
      "dateAdded": "2016-06-20",
      "subsets": [
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [],
      "hasItalic": true,
      "weights": [
        400,
        700
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/spacemono/OFL.txt",
        "localFile": "public/fonts/type-library/spaceMono/OFL.txt",
        "sha256": "8e4ee42b2553e1e01504e61cb0d46d148cd8c9e5eacaa3622a7df2d4f2955b9f"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/spacemono/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Space+Mono%3Aital%2Cwght%400%2C400%3B1%2C400%3B0%2C700%3B1%2C700&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/spacemono",
        "upstreamCommit": "329858c2c4dbd3476f972a4ae00624b018cf4b81",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/spaceMono/italic-400-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/spaceMono/italic-400-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spacemono/v17/i7dNIFZifjKcF5UAWdDRYERMSXK_MQacb0yG.woff2",
          "sha256": "099b3a34168b64961be6051130a6bf5effa9d2a927e5e48e4ef1c2c82a0aabea",
          "bytes": 10048,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/spaceMono/italic-400-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/spaceMono/italic-400-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spacemono/v17/i7dNIFZifjKcF5UAWdDRYERMR3K_MQacbw.woff2",
          "sha256": "7b001804bf97cfe4488183f1713fcb0f5312dd127526e423a8acd1a303c7dd12",
          "bytes": 10660,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/spaceMono/italic-700-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/spaceMono/italic-700-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spacemono/v17/i7dSIFZifjKcF5UAWdDRYERE_FeqEiSRRXaPY-je.woff2",
          "sha256": "a0297b33312ee20a153750b84191f6a9fd2a5f6d5a49ad7861cf2288ce3ba3a2",
          "bytes": 10096,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/spaceMono/italic-700-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/spaceMono/italic-700-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spacemono/v17/i7dSIFZifjKcF5UAWdDRYERE_FeqHCSRRXaPYw.woff2",
          "sha256": "bb03cb70d44305b604e4d814b4071a8239af4f9542fbbbb67113c5df329560f7",
          "bytes": 10500,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/spaceMono/normal-400-normal-latin-ext-5.woff2",
          "publicUrl": "/fonts/type-library/spaceMono/normal-400-normal-latin-ext-5.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spacemono/v17/i7dPIFZifjKcF5UAWdDRYE98RXi4EwSsbg.woff2",
          "sha256": "b4f90459adf4851575a46d9a492c17ee34c97fe40d56979521de67d1ee77d75a",
          "bytes": 9752,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/spaceMono/normal-400-normal-latin-6.woff2",
          "publicUrl": "/fonts/type-library/spaceMono/normal-400-normal-latin-6.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spacemono/v17/i7dPIFZifjKcF5UAWdDRYEF8RXi4EwQ.woff2",
          "sha256": "e0c8e616bda27642f4c3cebaecff6525d901e73afc8a227cbbb0f2af4810f300",
          "bytes": 9464,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/spaceMono/normal-700-normal-latin-ext-7.woff2",
          "publicUrl": "/fonts/type-library/spaceMono/normal-700-normal-latin-ext-7.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spacemono/v17/i7dMIFZifjKcF5UAWdDRaPpZUFuaHi6WZ3S_Yg.woff2",
          "sha256": "512458b32bf452ac0e4b33fd6277bf4f07821acefb59db2d1498aa107679a1a6",
          "bytes": 9732,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/spaceMono/normal-700-normal-latin-8.woff2",
          "publicUrl": "/fonts/type-library/spaceMono/normal-700-normal-latin-8.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spacemono/v17/i7dMIFZifjKcF5UAWdDRaPpZUFWaHi6WZ3Q.woff2",
          "sha256": "af7cf6d2b897ec453acdcdacde4e9bcc8410718af5914de865b453e09f10eebc",
          "bytes": 9552,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "spectral",
      "family": "Spectral",
      "slug": "spectral",
      "shelfId": "editorial-reading",
      "class": "serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "editorial",
        "literary",
        "measured",
        "credible"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "companyCredentials",
        "other"
      ],
      "lanes": [
        "editorial",
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not use literary texture as permission for paragraphs that should be slides apart.",
      "designer": "Production Type",
      "category": "SERIF",
      "dateAdded": "2017-10-10",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [],
      "hasItalic": true,
      "weights": [
        200,
        300,
        400,
        500,
        600,
        700,
        800
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/spectral/OFL.txt",
        "localFile": "public/fonts/type-library/spectral/OFL.txt",
        "sha256": "501d6ceca8e552630fe3aa9442b9a818565680a1a2f79f3fb8c13d6f309a9e98"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/spectral/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Spectral%3Aital%2Cwght%400%2C400%3B1%2C400%3B0%2C700%3B1%2C700&display=swap",
        "upstreamRepository": "https://github.com/productiontype/Spectral",
        "upstreamCommit": "dbc06862d7030eedb1b01b60cdad8f6102f4ddfa",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/spectral/italic-400-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/spectral/italic-400-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spectral/v15/rnCt-xNNww_2s0amA9M8onTmTNmnUHowCw.woff2",
          "sha256": "537c651195b85f73d4a434a72af3b328081e1a544395946d374fb9a957494a21",
          "bytes": 13528,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/spectral/italic-400-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/spectral/italic-400-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spectral/v15/rnCt-xNNww_2s0amA9M8onrmTNmnUHo.woff2",
          "sha256": "7cfafd3583aecfe216f860d7a1c5689e86f7f92681946ca582d042c1c96b37d7",
          "bytes": 14988,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/spectral/italic-700-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/spectral/italic-700-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spectral/v15/rnCu-xNNww_2s0amA9M8qsHDWfqFXVAKArdqqQ.woff2",
          "sha256": "547a0b62fee7afbdd5aeab6ca286555a87558ef068d9c2452912a3211dcac912",
          "bytes": 14216,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/spectral/italic-700-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/spectral/italic-700-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spectral/v15/rnCu-xNNww_2s0amA9M8qsHDWfSFXVAKArc.woff2",
          "sha256": "1fdd59a028cceea6bbcab1e10f2ccd3d92e6558319dd84180072354cbac3e035",
          "bytes": 16004,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/spectral/normal-400-normal-latin-ext-5.woff2",
          "publicUrl": "/fonts/type-library/spectral/normal-400-normal-latin-ext-5.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spectral/v15/rnCr-xNNww_2s0amA9M3knjsS_ulYHs.woff2",
          "sha256": "a62b9bdf669d8fb395c8685321cbf86c2f2bc324e0b28ecf867a036095383d49",
          "bytes": 12660,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/spectral/normal-400-normal-latin-6.woff2",
          "publicUrl": "/fonts/type-library/spectral/normal-400-normal-latin-6.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spectral/v15/rnCr-xNNww_2s0amA9M5knjsS_ul.woff2",
          "sha256": "bcb83e9c56d40c5111a2bdbc3d8bdabf66bd31337e968f1c223b61879b8d3cad",
          "bytes": 14028,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/spectral/normal-700-normal-latin-ext-7.woff2",
          "publicUrl": "/fonts/type-library/spectral/normal-700-normal-latin-ext-7.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spectral/v15/rnCs-xNNww_2s0amA9uCt23PafaPWnIIMrY.woff2",
          "sha256": "e06de276e6b69b3501de2ff0e45a7f159ba71bcca576f401098e09c0355e1ced",
          "bytes": 13312,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/spectral/normal-700-normal-latin-8.woff2",
          "publicUrl": "/fonts/type-library/spectral/normal-700-normal-latin-8.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/spectral/v15/rnCs-xNNww_2s0amA9uCt23BafaPWnII.woff2",
          "sha256": "1125ec621f11c8669efc3a86cc05d9e9e221853d2b1c9658d9e30de9d3b90bba",
          "bytes": 15180,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "syne",
      "family": "Syne",
      "slug": "syne",
      "shelfId": "geometric-voices",
      "class": "sans",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate",
        "varied"
      ],
      "tones": [
        "graphic",
        "contemporary",
        "confident",
        "constructed"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "startupInvestor",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not let the display face colonize paragraphs, labels and footnotes.",
      "designer": "Bonjour Monde, Lucas Descroix, George Triantafyllakos",
      "category": "DISPLAY",
      "dateAdded": "2020-08-25",
      "subsets": [
        "greek",
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 400,
          "max": 800
        }
      ],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/syne/OFL.txt",
        "localFile": "public/fonts/type-library/syne/OFL.txt",
        "sha256": "cc43cdce6f91c57989af8459341c276655e34224e954fa69c2ad700831a742d8"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/syne/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Syne%3Awght%40400..800&display=swap",
        "upstreamRepository": "https://gitlab.com/bonjour-monde/fonderie/syne-typeface",
        "upstreamCommit": "d9098c0a72125d411dbb225a2e5a61dc15265ffc",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/syne/normal-400-800-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/syne/normal-400-800-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/syne/v24/8vIH7w4qzmVxm25L9G78HEZnMg.woff2",
          "sha256": "79bc839264c4a3c9b988de4acbc0dcf0d9ca4b41e2df523940f81b78e3d6fdb3",
          "bytes": 14652,
          "style": "normal",
          "weight": "400 800",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/syne/normal-400-800-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/syne/normal-400-800-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/syne/v24/8vIH7w4qzmVxm2BL9G78HEY.woff2",
          "sha256": "cfff412005eed2f0152d1c110c78ac564642b943e64322fbd687083177d6fa70",
          "bytes": 34560,
          "style": "normal",
          "weight": "400 800",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "unbounded",
      "family": "Unbounded",
      "slug": "unbounded",
      "shelfId": "geometric-voices",
      "class": "sans",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate",
        "varied"
      ],
      "tones": [
        "wide",
        "strange",
        "futurist"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "startupInvestor",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not let the display face colonize paragraphs, labels and footnotes.",
      "designer": "The Unbounded Project Authors",
      "category": "SANS_SERIF",
      "dateAdded": "2022-11-07",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 200,
          "max": 900
        }
      ],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/unbounded/OFL.txt",
        "localFile": "public/fonts/type-library/unbounded/OFL.txt",
        "sha256": "31e5d4e83955e7103c34570dd49b0570ef490800bd65b42923c0dd02445263b3"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/unbounded/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Unbounded%3Awght%40200..900&display=swap",
        "upstreamRepository": "https://github.com/googlefonts/unbounded",
        "upstreamCommit": "f3ec43228a864a72487e41552e2140efab9884ea",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/unbounded/normal-200-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/unbounded/normal-200-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/unbounded/v12/Yq6W-LOTXCb04q32xlpwtcZfvRIkSYZH.woff2",
          "sha256": "ed84482df7b95e6a56a113de1ba2a8d54337f499ba19d54ca697a7e15427ff5f",
          "bytes": 117648,
          "style": "normal",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/unbounded/normal-200-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/unbounded/normal-200-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/unbounded/v12/Yq6W-LOTXCb04q32xlpwu8ZfvRIkSQ.woff2",
          "sha256": "d7f07f8a308ce0a7287d79a65a85cfbc0f4741ef426bf1a3902d24392cc71723",
          "bytes": 50892,
          "style": "normal",
          "weight": "200 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "urbanist",
      "family": "Urbanist",
      "slug": "urbanist",
      "shelfId": "geometric-voices",
      "class": "sans",
      "character": "expressive",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "sparse",
        "moderate",
        "varied"
      ],
      "tones": [
        "graphic",
        "contemporary",
        "confident",
        "constructed"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "startupInvestor",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not let the display face colonize paragraphs, labels and footnotes.",
      "designer": "Corey Hu",
      "category": "SANS_SERIF",
      "dateAdded": "2021-06-02",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/urbanist/OFL.txt",
        "localFile": "public/fonts/type-library/urbanist/OFL.txt",
        "sha256": "ee1221b1c2d08920e5f9ca764eb228dafa5c8090df9cf665373c2287b9cb8f49"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/urbanist/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Urbanist%3Aital%2Cwght%400%2C100..900%3B1%2C100..900&display=swap",
        "upstreamRepository": "https://github.com/coreyhu/Urbanist",
        "upstreamCommit": "549716453f76335ccc5a9e537cbe0da03d6fed34",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/urbanist/italic-100-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/urbanist/italic-100-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/urbanist/v18/L0x4DF02iFML4hGCyMqgXSFsjlC0V7q7Ag.woff2",
          "sha256": "7ecd791a418fe0b2ef492590e8dddd095c0b2148fd569e09f8902368bd5f2417",
          "bytes": 17204,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/urbanist/italic-100-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/urbanist/italic-100-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/urbanist/v18/L0x4DF02iFML4hGCyMqgXS9sjlC0V7o.woff2",
          "sha256": "62bb607e6d25cc8056cd2acc736af030bd1a44a8a4ff27b259fe629524b6514a",
          "bytes": 29520,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/urbanist/normal-100-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/urbanist/normal-100-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/urbanist/v18/L0x-DF02iFML4hGCyMqrbS1miXK2Z7s.woff2",
          "sha256": "2abe1ed29084b56909d14e0e3097ac292b513d4a2761241bb6267505ebf77145",
          "bytes": 16464,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/urbanist/normal-100-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/urbanist/normal-100-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/urbanist/v18/L0x-DF02iFML4hGCyMqlbS1miXK2.woff2",
          "sha256": "ce6e0dd89c3ffa4de97bda85f9b08bcb775bea4df456b3dbb7e819c1c879be50",
          "bytes": 27812,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "vollkorn",
      "family": "Vollkorn",
      "slug": "vollkorn",
      "shelfId": "editorial-reading",
      "class": "serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "editorial",
        "literary",
        "measured",
        "credible"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "companyCredentials",
        "other"
      ],
      "lanes": [
        "editorial",
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not use literary texture as permission for paragraphs that should be slides apart.",
      "designer": "Friedrich Althausen",
      "category": "SERIF",
      "dateAdded": "2010-09-08",
      "subsets": [
        "cyrillic",
        "cyrillic-ext",
        "greek",
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 400,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/vollkorn/OFL.txt",
        "localFile": "public/fonts/type-library/vollkorn/OFL.txt",
        "sha256": "53f9c99fa3d47f7d632a42ee7bab4a834a60a744f6026d676c3a223cef2b2ef3"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/vollkorn/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Vollkorn%3Aital%2Cwght%400%2C400..900%3B1%2C400..900&display=swap",
        "upstreamRepository": "https://github.com/FAlthausen/Vollkorn-Typeface",
        "upstreamCommit": "38ab7a896bd6b163ac7f834ec696d6c68e5dedd6",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/vollkorn/italic-400-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/vollkorn/italic-400-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/vollkorn/v30/0yb7GDoxxrvAnPhYGxksWEEeqTo29TfO-Q.woff2",
          "sha256": "871777e9a3cd6c3150b8085f7f921636fb02a423e37e0d2a3f2f0da38876ef5d",
          "bytes": 41212,
          "style": "italic",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/vollkorn/italic-400-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/vollkorn/italic-400-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/vollkorn/v30/0yb7GDoxxrvAnPhYGxksWE8eqTo29Tc.woff2",
          "sha256": "9f455bc807632f66cf74f5e69e5015d47f79b3cf6020e302af12e84b4c2a5280",
          "bytes": 47220,
          "style": "italic",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/vollkorn/normal-400-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/vollkorn/normal-400-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/vollkorn/v30/0yb9GDoxxrvAnPhYGxknaE0Urhg0xTY.woff2",
          "sha256": "ccf9e919bab356ba70a49bb136bb949be33b2cf6f5aa7b5830e205a07ebc308a",
          "bytes": 37692,
          "style": "normal",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/vollkorn/normal-400-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/vollkorn/normal-400-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/vollkorn/v30/0yb9GDoxxrvAnPhYGxkpaE0Urhg0.woff2",
          "sha256": "9378262a1abcdfc33f742dc59ee336e7d572f453f17437839ab7f1149c99e1a5",
          "bytes": 46348,
          "style": "normal",
          "weight": "400 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "workSans",
      "family": "Work Sans",
      "slug": "worksans",
      "shelfId": "clear-workhorses",
      "class": "sans",
      "character": "quiet",
      "roles": [
        "display",
        "body",
        "utility"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "clear",
        "plainspoken",
        "rigorous",
        "calm"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not confuse neutrality with an excuse to make every slide identical.",
      "designer": "Wei Huang",
      "category": "SANS_SERIF",
      "dateAdded": "2015-07-08",
      "subsets": [
        "latin",
        "latin-ext",
        "menu",
        "vietnamese"
      ],
      "axes": [
        {
          "tag": "wght",
          "min": 100,
          "max": 900
        }
      ],
      "hasItalic": true,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/worksans/OFL.txt",
        "localFile": "public/fonts/type-library/workSans/OFL.txt",
        "sha256": "749aca05078664ce682dce1b1b10096ac397cb088c1a6df4e1bb56f0092a9272"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/worksans/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Work+Sans%3Aital%2Cwght%400%2C100..900%3B1%2C100..900&display=swap",
        "upstreamRepository": "https://github.com/weiweihuanghuang/Work-Sans",
        "upstreamCommit": "b35c81086186162164947bd39574683073d9b268",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/workSans/italic-100-900-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/workSans/italic-100-900-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/worksans/v24/QGYqz_wNahGAdqQ43Rh_eZDlv_1i4_D2E4A.woff2",
          "sha256": "e5431364e5d49261787f4cdd0c8231b8fceb8e647d5940e788a8c382a32f88d4",
          "bytes": 32284,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/workSans/italic-100-900-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/workSans/italic-100-900-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/worksans/v24/QGYqz_wNahGAdqQ43Rh_eZDrv_1i4_D2.woff2",
          "sha256": "b87f48add7ec30528eec5bb08a62bedff58ec6093097d817d3def0c54691ad45",
          "bytes": 48264,
          "style": "italic",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/workSans/normal-100-900-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/workSans/normal-100-900-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/worksans/v24/QGYsz_wNahGAdqQ43Rh_cqDptfpA4cD3.woff2",
          "sha256": "fe0af300ce56932381af82ed960d8582dc8308ac2b7b48dd505dd49573a83ada",
          "bytes": 35776,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/workSans/normal-100-900-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/workSans/normal-100-900-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/worksans/v24/QGYsz_wNahGAdqQ43Rh_fKDptfpA4Q.woff2",
          "sha256": "72cd8f67849cc714f3364eeeb378df9a49f4aff00e6a3640fad36c9c93a9b197",
          "bytes": 50524,
          "style": "normal",
          "weight": "100 900",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "youngSerif",
      "family": "Young Serif",
      "slug": "youngserif",
      "shelfId": "expressive-serif",
      "class": "display-serif",
      "character": "expressive",
      "roles": [
        "display"
      ],
      "density": [
        "sparse",
        "moderate"
      ],
      "tones": [
        "dramatic",
        "tactile",
        "authored",
        "cinematic"
      ],
      "artifacts": [
        "filmTvProject",
        "directorTreatment",
        "advertisingTreatment",
        "agencyPitch"
      ],
      "lanes": [
        "characterful",
        "editorial",
        "wildcard"
      ],
      "oneThingNotToDo": "Do not turn every sentence into a costume change.",
      "designer": "Bastien Sozeau",
      "category": "SERIF",
      "dateAdded": "2023-08-30",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [],
      "hasItalic": false,
      "weights": [
        400
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/youngserif/OFL.txt",
        "localFile": "public/fonts/type-library/youngSerif/OFL.txt",
        "sha256": "737d8d343b674c6894f373de71a044b6782c130f2aebf180933d63ddf7a3dc19"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/youngserif/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Young+Serif%3Awght%40400&display=swap",
        "upstreamRepository": "https://github.com/noirblancrouge/YoungSerif",
        "upstreamCommit": "d307c79320df6b8ccc656b5ab83719519ddffc28",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/youngSerif/normal-400-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/youngSerif/normal-400-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/youngserif/v2/3qTpojO2nS2VtkB3KtkQZ1tz3kY6ah7ECjE.woff2",
          "sha256": "3d956f419542b44a9b33e7143923e86a9b0ae9b6e98f220e496b0160180750b0",
          "bytes": 11836,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/youngSerif/normal-400-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/youngSerif/normal-400-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/youngserif/v2/3qTpojO2nS2VtkB3KtkQZ1t93kY6ah7E.woff2",
          "sha256": "a46a84bfaa83dea2fa2d034dbf9b8f119a0872d78d28aa2cfe06ced9c1d2ef9e",
          "bytes": 18520,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    },
    {
      "id": "zillaSlab",
      "family": "Zilla Slab",
      "slug": "zillaslab",
      "shelfId": "sturdy-serifs",
      "class": "sturdy-serif",
      "character": "present",
      "roles": [
        "display",
        "body"
      ],
      "density": [
        "moderate",
        "dense",
        "varied"
      ],
      "tones": [
        "sturdy",
        "grounded",
        "substantial",
        "practical"
      ],
      "artifacts": [
        "startupInvestor",
        "agencyPitch",
        "companyCredentials",
        "salesPartnership",
        "other"
      ],
      "lanes": [
        "reliable",
        "editorial",
        "oneFamily"
      ],
      "oneThingNotToDo": "Do not mistake weight for authority; hierarchy still has to do the work.",
      "designer": "Typotheque",
      "category": "SERIF",
      "dateAdded": "2017-06-28",
      "subsets": [
        "latin",
        "latin-ext",
        "menu"
      ],
      "axes": [],
      "hasItalic": true,
      "weights": [
        300,
        400,
        500,
        600,
        700
      ],
      "license": {
        "spdx": "OFL-1.1",
        "sourceUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/zillaslab/OFL.txt",
        "localFile": "public/fonts/type-library/zillaSlab/OFL.txt",
        "sha256": "240b385d3ec8c8d5c1d4af2bbba6ac72bac0309a80c1a8ff112c168643cc6811"
      },
      "source": {
        "provider": "Google Fonts",
        "metadataUrl": "https://raw.githubusercontent.com/google/fonts/main/ofl/zillaslab/METADATA.pb",
        "cssRequestUrl": "https://fonts.googleapis.com/css2?family=Zilla+Slab%3Aital%2Cwght%400%2C400%3B1%2C400%3B0%2C700%3B1%2C700&display=swap",
        "upstreamRepository": "https://github.com/mozilla/zilla-slab",
        "upstreamCommit": "6dcec520f9b23ad7f380b7ce3e8072be95fe0004",
        "providerCommit": "389b770410cc0b7c21c85673bfa2077420fe7f65"
      },
      "previewStatus": "exact_self_hosted",
      "deckStatus": "requires_application_validation",
      "files": [
        {
          "file": "public/fonts/type-library/zillaSlab/italic-400-normal-latin-ext-1.woff2",
          "publicUrl": "/fonts/type-library/zillaSlab/italic-400-normal-latin-ext-1.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/zillaslab/v12/dFa4ZfeM_74wlPZtksIFaj8K8VSMdFJ6dZX9.woff2",
          "sha256": "0a4c58d05bd26a036c0693794ac1096bf649a349844b9abb502587e7ed7aca1c",
          "bytes": 10116,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/zillaSlab/italic-400-normal-latin-2.woff2",
          "publicUrl": "/fonts/type-library/zillaSlab/italic-400-normal-latin-2.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/zillaslab/v12/dFa4ZfeM_74wlPZtksIFaj8K_1SMdFJ6dQ.woff2",
          "sha256": "632fc06376adcdee986f468fc9c2ea03c1f94642a82f79ece521c6c2cb44eea5",
          "bytes": 17716,
          "style": "italic",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/zillaSlab/italic-700-normal-latin-ext-3.woff2",
          "publicUrl": "/fonts/type-library/zillaSlab/italic-700-normal-latin-ext-3.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/zillaslab/v12/dFanZfeM_74wlPZtksIFaj8CRHGZV3B3X6_0f1Nk.woff2",
          "sha256": "9d30c738da33b91f8382f46b1e205a2dcc2c8d7fa4bc3e05837100436862671a",
          "bytes": 10040,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/zillaSlab/italic-700-normal-latin-4.woff2",
          "publicUrl": "/fonts/type-library/zillaSlab/italic-700-normal-latin-4.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/zillaslab/v12/dFanZfeM_74wlPZtksIFaj8CRHGZWXB3X6_0fw.woff2",
          "sha256": "0e3e6a52bc9196fa2c5e14462607056894d0f1b4126d832dc5cdeda898c8a688",
          "bytes": 17620,
          "style": "italic",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/zillaSlab/normal-400-normal-latin-ext-5.woff2",
          "publicUrl": "/fonts/type-library/zillaSlab/normal-400-normal-latin-ext-5.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/zillaslab/v12/dFa6ZfeM_74wlPZtksIFajQ6_V6LVlBKdA.woff2",
          "sha256": "3ff404c7b778f359601d869d8b01cd0363b475a185d3ced3649f6063aed7d217",
          "bytes": 9452,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/zillaSlab/normal-400-normal-latin-6.woff2",
          "publicUrl": "/fonts/type-library/zillaSlab/normal-400-normal-latin-6.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/zillaslab/v12/dFa6ZfeM_74wlPZtksIFajo6_V6LVlA.woff2",
          "sha256": "90f974cf9aa18b562a98b0bbfd2670ef065f15dc56d39c26d826d71f7b9821e7",
          "bytes": 17168,
          "style": "normal",
          "weight": "400",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        },
        {
          "file": "public/fonts/type-library/zillaSlab/normal-700-normal-latin-ext-7.woff2",
          "publicUrl": "/fonts/type-library/zillaSlab/normal-700-normal-latin-ext-7.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/zillaslab/v12/dFa5ZfeM_74wlPZtksIFYoEf6H2pW3pwfa3Efg.woff2",
          "sha256": "413b9498c1fde415dfadc210e0234f2c36e84b41f1d46a2253f9a6c52add8a55",
          "bytes": 9340,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin-ext",
          "unicodeRange": "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF"
        },
        {
          "file": "public/fonts/type-library/zillaSlab/normal-700-normal-latin-8.woff2",
          "publicUrl": "/fonts/type-library/zillaSlab/normal-700-normal-latin-8.woff2",
          "sourceUrl": "https://fonts.gstatic.com/s/zillaslab/v12/dFa5ZfeM_74wlPZtksIFYoEf6HOpW3pwfa0.woff2",
          "sha256": "6d5ec30c781ce44aef71e9ea386f861a6a74db5dc162fbbc126fb522519c38a3",
          "bytes": 16788,
          "style": "normal",
          "weight": "700",
          "stretch": null,
          "subset": "latin",
          "unicodeRange": "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
        }
      ]
    }
  ]
}
